import { helpKo } from "./help.ko";

export const languageKorean = {
  formating: {
    main: "메인 프롬프트",
    jailbreak: "탈옥 프롬프트",
    chats: "과거 채팅",
    lorebook: "로어북",
    globalNote: "글로벌 노트",
    authorNote: "작가의 노트",
    lastChat: "마지막 채팅",
    description: "캐릭터 설명",
    personaPrompt: "페르소나 프롬프트",
    plain: "순수 프롬프트",
    memory: "장기 기억",
    postEverything: "최종 삽입 프롬프트",
  },
  errors: {
    toomuchtoken: "에러: 요청에 필요한 최소 토큰이 최대 토큰보다 큽니다.",
    unknownModel: "에러: 알수없는 모델 선택됨",
    httpError: "요청 에러:",
    noData: "올바른 파일이 아니거나 데이터가 손상됐습니다.",
    chatBodyMissing: "서버에서 이 채팅 내용을 찾지 못했습니다. 남아 있을 수 있는 메시지를 빈 채팅으로 덮어쓰지 않도록 그대로 두었습니다. 다른 기기나 백업을 확인하세요.",
    chatLoadFailed: "채팅을 불러오지 못했습니다. 연결을 확인한 뒤 다시 시도하세요.",
    chatLoadRetry: "다시 불러오기",
    onlyOneChat: "채팅이 하나 이상 필요합니다",
    onlyOnePreset: "프리셋이 하나 이상 필요합니다",
    noUserIcon: "유저 아이콘이 없습니다.",
    emptyText: "텍스트가 비어있습니다.",
    wrongPassword: "비밀번호가 잘못되었습니다.",
    networkFetch:
      "네트워크가 불안정하거나 서버가 응답하지 않을 때 자주 발생합니다.",
    networkFetchWeb:
      "이것은 CORS 오류일 수 있습니다. 이는 브라우저의 제한으로 인해 웹 버전을 사용할 때만 발생합니다. 데스크톱 로컬 버전이나 다른 버전의 PocketRisu를 사용해보세요.",
    networkFetchPlain:
      "이것은 요청 오류일 수 있습니다. 설정에서 직접 요청 보내기 옵션을 비활성화해 보세요.",
    requestLogRemoved: "요청 로그가 삭제되었습니다.",
    requestLogRemovedDesc:
      "요청 로그는 앱이 재시작되거나 새로고침되면 삭제됩니다.",
    vertexAuthError: "Vertex AI 인증 정보가 누락되었습니다.",
    coldStorageWriteFailed:
      "콜드 스토리지 저장에 실패했습니다. 채팅 데이터는 보존되었습니다.",
    coldStorageVerifyFailed:
      "콜드 스토리지 검증에 실패했습니다. 채팅 데이터는 보존되었습니다.",
    persistFailureTitle:
      "서버 저장 실패 — 변경사항이 디스크에 반영되지 않습니다",
    persistFailureAttemptedSize: "시도 크기",
    storageRequestTooLarge:
      "저장 요청이 너무 커서 실패했습니다 (HTTP 413). 서버 또는 리버스 프록시(Nginx 등)의 요청 본문 크기 제한을 확인하세요.",
    backupEncryptedAccount:
      "이 백업은 RisuAI 웹 버전(risuai.xyz)에서 내보낸 파일입니다. 데이터베이스가 암호화되어 있고 risuai.xyz에서만 열 수 있어 PocketRisu에서 읽을 수 없습니다. RisuAI에서 \"계정에 데이터 저장\"을 켠 뒤 설정 > 데이터 이전의 \"RisuAI 계정에서 가져오기\"를 쓰세요. 자세한 방법은 데이터 이전 가이드에 있습니다. 기존 데이터는 바뀌지 않았습니다.",
    chatGuardTitle: "채팅 데이터 보호 작동 — 안전 저장 모드로 전환됨",
    chatGuardDesc:
      "비정상적인 저장 패턴이 차단되어 안전 저장(full-write)으로 전환됐어요. 변경사항은 그 경로로 디스크에 저장됩니다. 반복되면 브라우저 콘솔 로그와 함께 제보해주세요.",
    chatGuardPersistTitle: "기존 채팅 데이터 보호를 위해 저장을 중단했어요",
    chatGuardPersistDesc:
      "서버에서 손상된 채팅 구조를 감지하여 디스크 기록을 거부했어요. 최근 변경사항이 아직 디스크에 반영되지 않았을 수 있으니 새로고침 전에 다시 확인해주세요. 기존 데이터는 안전합니다.",
    backgroundGenerationFailed: "백그라운드 생성 실패 ({char}): {error}",
    modelJobBusy:
      "이 채팅은 서버에서 아직 생성 중이에요. 완료되면 자동으로 채워지니 잠시 기다려주세요.",
    modelJobConnectionLost:
      "연결이 끊겼지만 서버에서 계속 생성 중이에요. 다시 돌아오면 자동으로 이어집니다 — 다시 보내지 않아도 돼요.",
    chatStillGenerating:
      "이 채팅은 아직 생성 중이에요. 완료되거나 중지한 뒤 다시 보내주세요.",
    otherChatGenerating:
      "다른 채팅에서 생성이 진행 중이에요. 그 채팅이 완료되거나 중지된 뒤 다시 보내주세요.",
    otherChatGenerationStopConfirm:
      "다른 채팅에서 3분 넘게 생성 중이라 멈췄을 수 있어요. 그 생성을 중지하고 여기서 보낼 수 있게 할까요?",
    generationForceReleased:
      "응답이 스스로 멈추지 않아 생성 상태를 강제로 정리했어요. 다시 보낼 수 있어요.",
    assetManifestConflictTitle: "다른 세션에서 에셋 목록이 변경되었습니다",
    assetManifestConflictDesc:
      "최신 에셋 페이지를 다시 불러왔습니다. 내용을 확인한 뒤 편집을 다시 시도해주세요.",
  },
  showHelp: "도움말 보기",
  help: helpKo,
  setup: {
    chooseProvider: "AI 제공자를 선택해 주세요",
    openaikey: "OpenAI & API Key (권장)",
    openaiProxy: "OpenAI 리버스 프록시",
    setupmodelself: "그외 / 직접 설정",
    inputApiKey: "여기에 API 키를 입력해주세요",
    apiKeyhelp: "이곳에서 API키를 얻을 수 있습니다: ",
    setupSelfHelp: "첫 셋업 화면이 끝난 뒤, 설정에서 직접 수정해 주세요",
    theme: "테마를 입력해 주세요",
    themeDescWifulike: "모바일에 적합하지 않습니다",
    themeDescWifuCut: "모바일 환경에 적합합니다",
    themeDescClassic: "모든 기기에 적합합니다",
    texttheme: "텍스트 색상을 선택해주세요",
    inputName: "마지막으로, 닉네임을 입력해 주세요",
    welcome:
      "PocketRisu에 오신 것을 환영해요! 저는 PocketRisu 셋업을 도와줄 아이리스라고 해요. 먼저 닉네임을 입력해 주세요!",
    welcome2:
      "{username}님 안녕하세요! PocketRisu를 시작하려면 몇 가지 설정만 하시면 되요. Ai 제공자를 선택해 주세요!",
    openRouterProvider:
      "OpenRouter는 여러 무료/유료 모델이 있습니다. 기본적으로 무료로 설정됩니다.",
    hordeProvider:
      "Horde는 특별한 설정이 필요없는 무료 모델입니다. 하지만, 성능이 좋지 않습니다.",
    setProviderLater: "다른 설정을 먼저 하고, 나중에 설정해도 됩니다.",
    setupOpenAI:
      "OpenAI를 사용하려면, API키가 필요해요. \n1. https://beta.openai.com/ 에 접속해주세요. \n2. 로그인 또는 회원가입 해주세요. \n3. https://beta.openai.com/account/api-keys 에 접속해주세요. \n4. 'Create New API Key'를 눌러주세요. \n5. 키 이름은 아무거나 하셔도 괜찮습니다. \n6.생성된 키를 복사해주세요.\n7. 리스AI로 돌아와 주세요.\n8. 입력칸에 붙여넣고, 전송 버튼을 눌러주세요.",
    setupClaude: "Claude를 사용하려면 API키가 필요해요.",
    setupClaudeSteps: [
      "이 URL로 이동하고 구글로 로그인하세요",
      "정보를 입력하고 'Continue'을 눌러주세요",
      "조직 페이지에서, 첫 번째 상자에 아무 이름만 입력하고 'Create Account'를 눌러주세요",
      "'Buy Credits' 버튼을 눌러주세요",
      "'Complete Setup' 버튼을 눌러주세요",
      "위 이미지와 같이 입력하되, 국가 부분은 자신의 국가를 입력해주세요. 그리고 'Continue'를 눌러주세요",
      "결제 방법을 추가하고 'Continue'를 눌러주세요",
      "결제가 등록되면 'Add Funds'를 눌러 자금을 추가하세요. 최소 5$를 추가할 수 있으며, 자동 추가 재충전을 설정할 수 있습니다.",
      "자금을 추가한 후, 대시보드 페이지로 이동하여 'Get API Keys' 버튼을 눌러주세요",
      "'Create API Key' 버튼을 눌러주세요",
      "위 이미지와 같이 입력하고 'Add'를 눌러주세요",
      "키를 복사하고, 이곳에 붙여넣고 전송해주세요.",
    ],
    setupOpenRouter:
      "OpenRouter를 사용하려면 API키가 필요합니다. \n1. https://openrouter.ai/keys 에 접속하고 로그인 또는 회원가입 해주세요.\n2. 'Create Key'를 눌러주세요. \n3. 키 이름은 아무거나 하셔도 괜찮습니다.\n4. 생성된 키를 복사해주세요.\n5. 리스AI로 돌아와주세요.\n6. 입력칸에 붙여넣고, 전송 버튼을 눌러주세요.",
    allDone:
      "모든 설정이 끝났어요! 잠시만 기다려주세요. 나머지 작업은 제가 처리할게요.",
    setupLaterMessage:
      "{username}님 환영해요! 셋업을 직접 하겠어요? 아니면 제 가이드를 받아보실래요?",
    setupMessageOption1: "셋업을 가이드해주세요",
    setupMessageOption1Desc: "신규 사용자에게 추천합니다",
    setupMessageOption2: "직접 설정하겠습니다",
    claudeDesc:
      "Claude는 Antropic에서 만든 AI 모델로, 영어 이외의 언어를 사용한다면 OpenAI보다 더 나은 선택입니다.",
    openAIDesc:
      "OpenAI GPT는 높은 품질의 AI 모델이지만, 유료이며 검열이 있으며, 영어 이외의 언어에서는 약합니다.",
    chooseChatType:
      "채팅 언어를 선택해 주세요! 개인적으론, '언어에 집중하지 않음'을 추천해요!",
    chooseChatTypeOption1: "전체 영어",
    chooseChatTypeOption1Desc:
      "AI가 영어를 사용하고, 입력/출력이 영어로 됩니다. 영어 사용자에게 추천합니다.",
    chooseChatTypeOption2: "영어 처리",
    chooseChatTypeOption2Desc:
      "AI가 내부적으로 영어를 사용하지만, 입력/출력은 사용자의 언어로 됩니다. 영어 이외의 언어 사용자에게 추천합니다.",
    chooseChatTypeOption3: "언어에 집중하지 않음",
    chooseChatTypeOption3Desc:
      "AI가 내부적으로 사용자의 언어를 사용하지만, 품질이 낮아질 수 있습니다.",
    chooseCheapOrMemory:
      "기억력과 가격 중 어느 것을 선호하세요? 잘 모르겠으면 균형으로 해주세요!",
    chooseCheapOrMemoryOption1: "기억력",
    chooseCheapOrMemoryOption1Desc:
      "AI가 더 많이 기억하지만, 비용이 많이 들 수 있습니다.",
    chooseCheapOrMemoryOption2: "가격",
    chooseCheapOrMemoryOption2Desc:
      "AI가 덜 기억하지만, 비용이 적게 들 수 있습니다.",
    chooseCheapOrMemoryOption3: "균형",
    chooseCheapOrMemoryOption3Desc:
      "AI가 가격보다는 더 많이 기억하지만, 기억보다는 적게 기억합니다.",
    chooseCheapOrMemoryOption4: "무제한",
    chooseCheapOrMemoryOption4Desc:
      "AI가 거의 모든 것을 기억하지만, 매우 비싸게 들 수 있습니다.",
    finally:
      "아, 그리고 고급 도구를 활성화할까요? 처음이시라면 켜지 않는 것이 좋아요.",
    finallyOption1: "예",
    finallyOption1Desc:
      "이것은 고급 도구를 활성화하며, UI를 더 복잡하게 만듭니다. 고급 사용자에게 추천합니다.",
    finallyOption2: "아니요",
    finallyOption2Desc:
      "이것은 고급 도구를 비활성화하며, UI를 더 간단하게 만듭니다. 신규 사용자에게 추천합니다.",
    igpPrompt:
      "IGP 프롬프트가 비어있지 않으면, 메인 모델 요청 후, 메인 모델 실행 후에 감정 모델로 실행되어 결과를 메인 모델 응답 뒤에 추가합니다.",
  },
  triggerCategories: {
    Special: "특수",
    Control: "제어",
    Chat: "채팅",
    "Low Level": "저수준 접근",
    Alert: "알림",
    "Lorebook V2": "로어북",
    String: "문자열",
    Data: "데이터",
    Array: "배열",
    Others: "기타",
    Deprecated: "비권장",
  },
  triggerDesc: {
    v2Header: "헤더",
    v2HeaderDesc: "헤더",
    v2If: "만약 ~이라면",
    v2IfDesc: "만약 {{source}} {{condition}} {{target}} 이라면",
    v2Else: "아닐 경우",
    v2ElseDesc: "아닐 경우",
    v2EndIndent: "들여쓰기 끝",
    v2EndIndentDesc: "들여쓰기 끝",
    v2SetVar: "변수 설정",
    v2SetVarDesc: "변수 {{var}} {{operator}} {{value}}",
    v2Loop: "계속 반복하기",
    v2LoopDesc: "계속 반복하기",
    v2BreakLoop: "반복 중단",
    v2BreakLoopDesc: "반복 중단",
    v2RunTrigger: "트리거 실행",
    v2RunTriggerDesc: "트리거 {{target}} 실행",
    v2ConsoleLog: "콘솔 로그",
    v2ConsoleLogDesc: "{{source}} 를 로그에 출력",
    v2StopTrigger: "트리거 중단",
    v2StopTriggerDesc: "트리거 중단",
    v2CutChat: "대화 부분 잘라내기",
    v2CutChatDesc: "{{start}} 에서 {{end}} 까지 대화 잘라내기",
    v2ModifyChat: "대화 수정",
    v2ModifyChatDesc: "인덱스 {{index}} 에 있는 대화를 {{value}} 로 수정",
    v2SystemPrompt: "시스템 프롬프트 추가",
    v2SystemPromptDesc: "{{location}} 에 시스템 프롬프트 {{value}} 추가",
    v2Impersonate: "대화 보내기",
    v2ImpersonateDesc: "{{role}} 대화 {{value}} 보내기",
    v2Command: "명령어 실행",
    v2CommandDesc: "{{value}} 명령어 실행",
    v2SendAIprompt: "AI 프롬프트 전송",
    v2SendAIpromptDesc: "AI 프롬프트 전송",
    v2ImgGen: "이미지 생성",
    v2ImgGenDesc: "{{value}} 프롬프트로 이미지 생성 => {{outputVar}}",
    v2CheckSimilarity: "유사도 확인",
    v2CheckSimilarityDesc:
      "{{source}} 와 {{value}} 의 유사도 확인 => {{outputVar}}",
    v2RunLLM: "모델 실행",
    v2RunLLMDesc: "{{value}} 을 모델에 요청 => {{outputVar}}",
    v2ShowAlert: "알림 표시",
    v2ShowAlertDesc: "{{value}} 로 알림 표시",
    v2ExtractRegex: "정규식 추출",
    v2ExtractRegexDesc:
      "{{value}} 에서 정규식  {{regex}} 및 플래그 {{flags}} 를 사용하여 텍스트 추출, 결과를 {{result}} 로 저장 => {{outputVar}}",
    v2RegexTest: "정규식 테스트",
    v2RegexTestDesc:
      "{{value}} 에서 정규식 {{regex}} 및 플래그 {{flags}} 로 매칭 테스트 => {{outputVar}}",
    v2GetLastMessage: "마지막 메시지 가져오기",
    v2GetLastMessageDesc: "마지막 메시지 가져오기 => {{outputVar}}",
    v2GetMessageAtIndex: "인덱스에서 메시지 가져오기",
    v2GetMessageAtIndexDesc:
      "인덱스 {{index}} 에서 메시지 가져오기 => {{outputVar}}",
    v2GetMessageCount: "메시지 개수 가져오기",
    v2GetMessageCountDesc: "메시지 개수 가져오기 => {{outputVar}}",
    v2GetLorebook: "로어북 가져오기",
    v2GetLorebookDesc: "로어북 {{target}} 가져오기 => {{outputVar}}",
    v2GetLorebookCount: "로어북 개수 가져오기",
    v2GetLorebookCountDesc: "로어북 개수 가져오기 => {{outputVar}}",
    v2GetLorebookEntry: "인덱스에서 로어북 가져오기",
    v2GetLorebookEntryDesc:
      "인덱스 {{index}} 에 있는 로어북 가져오기 => {{outputVar}}",
    v2SetLorebookActivation: "로어북 활성화 설정",
    v2SetLorebookActivationDesc:
      "인덱스 {{index}} 에 있는 로어북의 활성화 상태를 {{value}} 로 설정",
    v2GetLorebookIndexViaName: "이름으로 로어북 인덱스 가져오기",
    v2GetLorebookIndexViaNameDesc:
      "이름 {{name}} 인 로어북의 인덱스 가져오기 => {{outputVar}}",
    v2ModifyLorebook: "로어북 수정",
    v2ModifyLorebookDesc: "로어북 {{target}} 을 {{value}} 로 수정",
    v2LoopNTimes: "N번 반복하기",
    v2LoopNTimesDesc: "{{value}} 번 반복하기",
    v2Random: "랜덤",
    v2RandomDesc: "{{min}} 에서 {{max}} 까지의 랜덤 값 => {{outputVar}}",
    v2GetCharAt: "문자열에서 N번째 문자 가져오기",
    v2GetCharAtDesc:
      "{{source}} 의 {{index}} 번째 문자 가져오기 => {{outputVar}}",
    v2GetCharCount: "문자 개수 가져오기",
    v2GetCharCountDesc: "{{source}} 의 문자 개수 가져오기 => {{outputVar}}",
    v2ToLowerCase: "소문자로 변환",
    v2ToLowerCaseDesc: "{{source}} 를 소문자로 변환 => {{outputVar}}",
    v2ToUpperCase: "대문자로 변환",
    v2ToUpperCaseDesc: "{{source}} 를 대문자로 변환 => {{outputVar}}",
    v2SetCharAt: "문자열의 N번째 문자 변경",
    v2SetCharAtDesc:
      "{{source}} 의 {{index}} 번째 문자를 {{value}} 로 변경 => {{outputVar}}",
    v2SplitString: "문자열 분할",
    v2SplitStringDesc: "{{source}} 를 {{delimiter}} 로 분할 => {{outputVar}}",
    v2GetCharacterDesc: "캐릭터 설명 가져오기",
    v2GetCharacterDescDesc: "캐릭터 설명 가져오기 => {{outputVar}}",
    v2SetCharacterDesc: "캐릭터 설명 설정",
    v2SetCharacterDescDesc: "캐릭터 설명을 {{value}} 로 설정",
    v2GetPersonaDesc: "페르소나 프롬프트 가져오기",
    v2GetPersonaDescDesc: "페르소나 프롬프트 가져오기 => {{outputVar}}",
    v2SetPersonaDesc: "페르소나 프롬프트 설정",
    v2SetPersonaDescDesc: "페르소나 프롬프트를 {{value}} 로 설정",
    v2GetReplaceGlobalNote: "글로벌 노트 덮어쓰기 가져오기",
    v2GetReplaceGlobalNoteDesc:
      "글로벌 노트 덮어쓰기 가져오기 => {{outputVar}}",
    v2SetReplaceGlobalNote: "글로벌 노트 덮어쓰기 설정",
    v2SetReplaceGlobalNoteDesc: "글로벌 노트 덮어쓰기를 {{value}} 로 설정",
    v2GetAuthorNote: "작가의 노트 가져오기",
    v2GetAuthorNoteDesc: "작가의 노트 가져오기 => {{outputVar}}",
    v2SetAuthorNote: "작가의 노트 설정",
    v2SetAuthorNoteDesc: "작가의 노트를 {{value}} 로 설정",
    v2Comment: "주석 삽입",
    v2CommentDesc: "{{value}}",
    v2DeclareLocalVar: "지역변수 선언",
    v2DeclareLocalVarDesc: "지역변수 {{var}} 를 {{value}} 로 선언",
    v2MakeArrayVar: "배열 변수 생성",
    v2MakeArrayVarDesc: "배열 변수 {{var}} 생성",
    v2GetArrayVarLength: "배열 변수 길이 가져오기",
    v2GetArrayVarLengthDesc:
      "배열 변수 {{var}} 의 길이 가져오기 => {{outputVar}}",
    v2GetArrayVar: "배열 변수 가져오기",
    v2GetArrayVarDesc:
      "배열 변수 {{var}} 의 {{index}} 번째 값 가져오기 => {{outputVar}}",
    v2SetArrayVar: "배열 변수 설정",
    v2SetArrayVarDesc:
      "배열 변수 {{var}} 의 {{index}} 번째 값을 {{value}} 로 설정",
    v2PushArrayVar: "배열 변수 가장 뒤에 값 추가",
    v2PushArrayVarDesc: "배열 변수 {{var}} 의 가장 뒤에 {{value}} 추가",
    v2PopArrayVar: "배열 변수에서 마지막 값 제거 후 가져오기",
    v2PopArrayVarDesc: "배열 변수 {{var}} 에서 마지막 값 제거 => {{outputVar}}",
    v2ShiftArrayVar: "배열 변수에서 첫 값 제거 후 가져오기",
    v2ShiftArrayVarDesc: "배열 변수 {{var}} 에서 첫 값 제거 => {{outputVar}}",
    v2UnshiftArrayVar: "배열 변수에 첫 값 추가",
    v2UnshiftArrayVarDesc: "배열 변수 {{var} }에 {{value}} 첫 값으로 추가",
    v2SpliceArrayVar: "배열 변수 가운데에 값 추가",
    v2SpliceArrayVarDesc: "배열 변수 {{var}} 의 {{start}}에 {{item}} 추가",
    v2SliceArrayVar: "배열 변수 슬라이스",
    v2SliceArrayVarDesc:
      "배열 변수 {{var}} 의 {{start}} 부터 {{end}} 까지 슬라이스 => {{outputVar}}",
    v2GetIndexOfValueInArrayVar: "배열 변수에서 값의 인덱스 가져오기",
    v2GetIndexOfValueInArrayVarDesc:
      "배열 변수 {{var}} 에서 값 {{value}} 의 인덱스 가져오기 => {{outputVar}}",
    v2RemoveIndexFromArrayVar: "배열 변수에서 인덱스에 있는 값 제거",
    v2RemoveIndexFromArrayVarDesc:
      "배열 변수 {{var}} 에서 인덱스 {{index}} 에 있는 값 제거",
    v2JoinArrayVar: "배열 결합",
    v2JoinArrayVarDesc:
      "배열 {{var}} 를 {{delimiter}} 로 결합 => {{outputVar}}",
    v2MakeDictVar: "딕셔너리 변수 생성",
    v2MakeDictVarDesc: "딕셔너리 변수 {{var}} 생성",
    v2GetDictVar: "딕셔너리 값 가져오기",
    v2GetDictVarDesc:
      "딕셔너리 {{var}} 에서 키 {{key}} 의 값 가져오기 => {{outputVar}}",
    v2SetDictVar: "딕셔너리 값 설정",
    v2SetDictVarDesc: "딕셔너리 {{var}} 의 키 {{key}} 에 {{value}} 설정",
    v2DeleteDictKey: "딕셔너리 키 삭제",
    v2DeleteDictKeyDesc: "딕셔너리 {{var}} 에서 키 {{key}} 삭제",
    v2HasDictKey: "딕셔너리 키 존재 확인",
    v2HasDictKeyDesc:
      "딕셔너리 {{var}} 에 키 {{key}} 존재 확인 => {{outputVar}}",
    v2ClearDict: "딕셔너리 비우기",
    v2ClearDictDesc: "딕셔너리 {{var}} 비우기",
    v2GetDictSize: "딕셔너리 크기 가져오기",
    v2GetDictSizeDesc: "딕셔너리 {{var}} 의 크기 가져오기 => {{outputVar}}",
    v2GetDictKeys: "딕셔너리 키 목록 가져오기",
    v2GetDictKeysDesc: "딕셔너리 {{var}} 의 모든 키 가져오기 => {{outputVar}}",
    v2GetDictValues: "딕셔너리 값 목록 가져오기",
    v2GetDictValuesDesc:
      "딕셔너리 {{var}} 의 모든 값 가져오기 => {{outputVar}}",
    v2ConcatString: "문자열 합치기",
    v2ConcatStringDesc: "{{source1}} 와 {{source2}} 를 합치기 => {{outputVar}}",
    v2GetLastUserMessage: "마지막 유저 메시지 가져오기",
    v2GetLastUserMessageDesc: "마지막 유저 메시지 가져오기 => {{outputVar}}",
    v2GetLastCharMessage: "마지막 캐릭터 메시지 가져오기",
    v2GetLastCharMessageDesc: "마지막 캐릭터 메시지 가져오기 => {{outputVar}}",
    v2GetFirstMessage: "첫 메시지 가져오기",
    v2GetFirstMessageDesc: "첫 메시지 가져오기 => {{outputVar}}",
    v2GetAlertInput: "알림 입력창",
    v2GetAlertInputDesc: "알림 입력창 => {{outputVar}}",
    v2GetAlertSelect: "알림 선택창",
    v2GetAlertSelectDesc:
      "알림 선택창 {{display}} 선택지 {{value}} => {{outputVar}}",
    v2UnsupportedTrigger: "미지원 트리거",
    v2UnsupportedTriggerDesc: "지원되지 않는 트리거",
    v2GetDisplayState: "현재 디스플레이 데이터 가져오기",
    v2GetDisplayStateDesc: "현재 디스플레이 테이터 가져오기 => {{outputVar}}",
    v2SetDisplayState: "디스플레이 바꾸기",
    v2SetDisplayStateDesc: "디스플레이 상태를 {{value}} 로 설정",
    v2UpdateGUI: "GUI 업데이트",
    v2UpdateGUIDesc: "GUI 업데이트",
    v2UpdateChatAt: "인덱스의 채팅 업데이트",
    v2UpdateChatAtDesc: "{{index}} 의 채팅 다시 그리기",
    v2Wait: "기다리기",
    v2WaitDesc: "{{value}} 초 기다리기",
    v2GetRequestState: "리퀘스트 데이터 내용 가져오기",
    v2GetRequestStateDesc:
      "{{index}} 에서 리퀘스트 내용 가져오기 => {{outputVar}}",
    v2SetRequestState: "리퀘스트 데이터 내용 설정",
    v2SetRequestStateDesc:
      "{{index}} 에 있는 리퀘스트 내용을 {{value}} 로 설정",
    v2GetRequestStateRole: "리퀘스트 데이터 역할 가져오기",
    v2GetRequestStateRoleDesc:
      "{{index}} 에서 리퀘스트 데이터 역할 가져오기 => {{outputVar}}",
    v2SetRequestStateRole: "리퀘스트 데이터 역할 설정",
    v2SetRequestStateRoleDesc:
      "{{index}} 에 있는 리퀘스트 데이터 역할을 {{value}} 로 설정",
    v2GetRequestStateLength: "리퀘스트 데이터 길이 가져오기",
    v2GetRequestStateLengthDesc:
      "리퀘스트 데이터 길이 가져오기 => {{outputVar}}",
    v2IfAdvanced: "만약 ~이라면",
    v2IfAdvancedDesc: "만약 {{source}} {{condition}} {{target}} 이라면",
    v2QuickSearchChat: "빠른 채팅 검색",
    v2QuickSearchChatDesc:
      "{{value}} 를 {{depth}} 깊이에서 {{condition}} 방식으로 검색 => {{outputVar}}",
    v2StopPromptSending: "프롬프트 전송 중단",
    v2StopPromptSendingDesc: "프롬프트 전송 중단",
    v2Tokenize: "토큰화",
    v2TokenizeDesc: "{{value}} 를 토큰화 => {{outputVar}}",
    v2GetAllLorebooks: "전체 로어북 가져오기",
    v2GetAllLorebooksDesc:
      "전체 로어북의 프롬프트를 배열로 가져오기 => {{outputVar}}",
    v2GetLorebookByName: "이름으로 로어북 인덱스 가져오기",
    v2GetLorebookByNameDesc:
      "이름 {{name}} 으로 로어북 인덱스 배열 가져오기 => {{outputVar}}",
    v2GetLorebookByIndex: "로어북 가져오기",
    v2GetLorebookByIndexDesc:
      "인덱스 {{index}} 의 로어북 프롬프트 가져오기 => {{outputVar}}",
    v2CreateLorebook: "로어북 생성",
    v2CreateLorebookDesc:
      "이름 {{name}}, 키 {{key}}, 내용 {{content}} 으로 로어북 생성",
    v2ModifyLorebookByIndex: "로어북 수정",
    v2ModifyLorebookByIndexDesc:
      "인덱스 {{index}} 의 로어북을 이름 {{name}}, 키 {{key}}, 내용 {{content}} 으로 수정",
    v2DeleteLorebookByIndex: "로어북 삭제",
    v2DeleteLorebookByIndexDesc: "인덱스 {{index}} 의 로어북 삭제",
    v2GetLorebookCountNew: "로어북 개수 가져오기",
    v2GetLorebookCountNewDesc: "전체 로어북 개수 가져오기 => {{outputVar}}",
    v2SetLorebookAlwaysActive: "로어북 언제나 활성화 설정",
    v2SetLorebookAlwaysActiveDesc:
      "인덱스 {{index}} 의 로어북 언제나 활성화를 {{value}} 로 설정",
    v2Calculate: "연산",
    v2CalculateDesc: "{{expression}} 연산 => {{outputVar}}",
    v2ReplaceString: "문자열 치환",
    v2ReplaceStringDesc:
      "{{source}} 에서 정규식 {{regex}} 를 {{replacement}} 로 치환 => {{outputVar}}",
  },
  triggerInputLabels: {
    value: "값",
    var: "변수",
    varName: "변수명",
    outputVar: "출력 변수",
    name: "이름",
    index: "인덱스",
    source: "대상",
    target: "타겟",
    condition: "조건",
    operator: "연산자",
    role: "역할",
    location: "위치",
    prompt: "프롬프트",
    model: "모델",
    start: "시작",
    end: "끝",
    min: "최소값",
    max: "최대값",
    delimiter: "구분자",
    depth: "깊이",
    key: "키",
    alertContent: "알림 내용",
    options: "선택지",
    cmd: "명령어",
    regex: "정규식",
    replacement: "치환값",
    flags: "플래그",
    negPrompt: "네거티브 프롬프트",
    resultFormat: "결과 형식",
    activationKeys: "활성화 키",
    insertOrder: "배치 순서",
    sysStart: "시스템 시작",
    sysHistoryEnd: "시스템 히스토리 끝",
    sysPromptEnd: "시스템 프롬프트 끝",
    addElse: "else 추가",
    alwaysActive: "항상 활성화",
    trigger: "트리거",
    triggerOn: "트리거 시점",
    valueTypeDesc: "직접 입력한 값을 사용",
    varTypeDesc: "변수에 저장된 값을 사용",
    conditionEqual: "같음 (=)",
    conditionNotEqual: "다름 (≠)",
    conditionGreater: "큼 (>)",
    conditionLess: "작음 (<)",
    conditionGreaterEqual: "크거나 같음 (≥)",
    conditionLessEqual: "작거나 같음 (≤)",
    conditionSimilar: "유사 (≒)",
    conditionContains: "포함 (∋)",
    conditionIn: "속함 (∈)",
    conditionNotContains: "포함하지 않음 (∌)",
    conditionNotIn: "속하지 않음 (∉)",
    conditionTruthy: "참 여부 (≡)",
    operatorSet: "설정 (=)",
    operatorAdd: "더하기 (+=)",
    operatorSubtract: "빼기 (-=)",
    operatorMultiply: "곱하기 (*=)",
    operatorDivide: "나누기 (/=)",
    operatorModulo: "나머지 (%=)",
    searchLoose: "느슨한 검색",
    searchStrict: "엄격한 검색",
    searchRegex: "정규식 검색",
    modelMain: "메인 모델",
    modelSub: "보조 모델",
    roleUser: "user",
    roleChar: "char",
    roleSystem: "system",
    roleAssistant: "assistant",
    boolTrue: "True",
    boolFalse: "False",
    boolNull: "Null",
    helpVarName: "변수의 이름을 입력하세요",
    helpOutputVar: "결과를 저장할 변수명을 입력하세요",
    helpIndex: "배열이나 메시지의 인덱스 번호",
    helpRegex: "정규식 패턴을 입력하세요",
    helpFlags: "정규식 플래그",
    helpDelimiter: "문자열을 나눌 구분자",
    helpActivationKeys: "쉼표로 구분된 활성화 키워드",
    helpInsertOrder: "삽입 순서",
    helpDepth: "검색할 메시지 깊이",
    helpMinMax: "최소값과 최대값 범위",
    helpSlot: "변경하지 않으려면 {{slot}}을 사용하세요",
    expression: "수식",
  },
  playground: {
    playground: "플레이그라운드",
    inlayDeleteConfirm: '"{name}"을(를) 정말 삭제하시겠습니까?',
    inlayDeleteMultipleConfirm:
      "선택한 {count}개의 에셋을 정말 삭제하시겠습니까?",
    inlayDeleteSelected: "선택 항목 삭제",
    inlayDeselectAll: "모두 선택 해제",
    inlayEmpty: "저장된 인레이 에셋이 없습니다",
    inlayEmptyDesc:
      "채팅에서 첨부 또는 생성된 이미지, 오디오 및 비디오가 여기에 나타납니다",
    inlayExplorer: "인레이 에셋 탐색기",
    inlayImageGallery: "인레이 이미지",
    inlayImageGalleryEmptyDesc:
      "채팅에서 첨부 또는 생성된 이미지가 여기에 나타납니다",
    inlayImageList: "이미지 목록",
    inlaySelectAll: "모두 선택",
    inlayTotalAssets: "총 {count}개 에셋",
    inlayDelete: "삭제",
    inlayLoadingMore: "불러오는 중...",
    inlayCreatedAt: "생성:",
    inlayUpdatedAt: "수정:",
    inlaySort: "정렬",
    inlaySortUpdatedDesc: "최근 수정순",
    inlaySortUpdatedAsc: "오래된 수정순",
    inlaySortCreatedDesc: "최근 생성순",
    inlaySortCreatedAsc: "오래된 생성순",
    inlayFilter: "필터",
    inlayFilterAll: "전체",
    inlayFilterMetaMissing: "메타 없음",
    inlayFilterOrphanCharacter: "고아 캐릭터",
    inlayFilterOrphanChat: "고아 채팅",
    inlayOriginalLoadNeeded: "원본 로드 필요",
    inlayAudioAsset: "오디오 에셋",
    inlayVideoAsset: "비디오 에셋",
    inlaySignatureAsset: "서명 에셋",
    inlayInfo: "정보",
    inlayManualMapping: "수동 맵핑",
    inlayActions: "작업",
    inlayLoadingOriginal: "원본 이미지 불러오는 중...",
    inlaySave: "저장",
    inlaySaved: "저장됨!",
    inlayFilterOrphanMessage: "메시지에 없음",
    inlayScanMessages: "메시지 스캔",
    inlayScanning: "스캔 중...",
    inlayScanFailed: "메시지 스캔에 실패해 미참조 목록을 표시하지 않습니다",
    inlayDeleteSkippedReferenced: "다시 스캔한 결과 참조가 확인된 {count}개는 삭제에서 제외했습니다",
    inlayScanDone: "{count}개 메시지 스캔 완료",
  },
  confirm: "확인",
  yes: "예",
  no: "아니오",
  goback: "뒤로",
  botSettings: "봇 설정",
  model: "모델",
  apiKey: "API 키",
  providerURL: "요청 URL",
  providerJSON: "요청 JSON",
  mainPrompt: "메인 프롬프트",
  jailbreakPrompt: "탈옥 프롬프트",
  globalNote: "글로벌 노트",
  autoSuggest: "자동 제안",
  tokens: "토큰",
  maxContextSize: "최대 컨텍스트 크기",
  maxResponseSize: "최대 응답 크기",
  temperature: "온도",
  frequencyPenalty: "빈도 패널티",
  presensePenalty: "프리센스 패널티",
  advancedSettings: "고급 설정",
  advancedSettingsWarn: "어떤 설정인지 모르겠으면, 만지지 마세요!",
  formatingOrder: "포맷 순서",
  authorNote: "작가의 노트",
  firstMessage: "첫 메시지",
  description: "설명",
  note: "메모",
  jailbreakToggle: "탈옥 토글",
  charIcon: "캐릭터 아이콘",
  characterDisplay: "캐릭터 디스플레이",
  viewScreen: "추가적 캐릭터 스크린",
  none: "없음",
  emotionImage: "감정 이미지",
  noImages: "이미지 없음",
  noBias: "Bias 없음",
  image: "이미지",
  name: "이름",
  characterName: "캐릭터 이름",
  characterInfo: "캐릭터 정보",
  folderName: "폴더 이름",
  folderRemoveConfirm:
    "이 폴더에는 로어북이 포함되어 있습니다. 폴더와 그 안의 모든 항목을 삭제하시겠습니까?",
  emotion: "감정 이름",
  value: "값",
  reroll: "재생성",
  deleteRerollMessage: "재생성된 메세지 삭제",
  deleteRerollMessageConfirm: "현재 선택된 재생성 메세지를 삭제할까요?",
  rerollConfirm: "재생성하여 신규 메세지를 목록에 추가 할까요?",
  noSwipesRerollConfirm:
    "현재는 추가 재생성된 메세지가 없습니다. 재생성하여 신규 메세지를 목록에 추가 할까요?",
  chatList: "채팅 리스트",
  removeChat: "이 메시지를 삭제하시겠습니까?",
  loreBook: "로어북",
  character: "캐릭터",
  Chat: "챗",
  globalLoreInfo: "캐릭터 로어북은 이 캐릭터의 모든 채팅에 적용됩니다.",
  group: "그룹",
  localLoreInfo: "챗 로어북은 이 채팅에만 적용됩니다.",
  removeConfirm: "정말로 삭제하시겠습니까: ",
  removeConfirm2: "정말로, 정말로 삭제하시겠습니까: ",
  exportConfirm: "엑스포트하시겠습니까?",
  insertOrder: "배치 순서",
  activationKeys: "활성화 키",
  activationKeysInfo: '","로 나눠주세요',
  prompt: "프롬프트",
  loreBookDepth: "로어북 검색 깊이",
  loreBookToken: "로어북 최대 토큰",
  chatLoadInitialPages: "채팅 초기 로딩 개수",
  chatLoadAdditionalPages: "채팅 추가 로딩 개수",
  removeCharacter: "캐릭터 삭제",
  deactivateCharacter: "캐릭터 비활성화",
  deactivateCharacterConfirm: (name: string) =>
    `"${name}" 캐릭터와 채팅을 비활성화합니다.\n\n사용하지 않는 캐릭터를 비활성화하면 로딩과 저장이 가벼워져 성능 개선에 도움이 됩니다. 목록에는 남지만 열 수 없고, 플러그인이나 스크립트, 검색, 데이터셋 내보내기에서는 삭제된 것처럼 보입니다. 데이터는 서버에 보관되며 언제든 다시 활성화할 수 있습니다.\n\n비활성화할까요?`,
  deactivateCharacterDone: "캐릭터를 비활성화했습니다.",
  deactivateCharacterLostChats: (name: string, count: number, list: string) =>
      `"${name}"의 채팅 ${count}개는 서버에도 이 브라우저에도 내용이 없어 열면 빈 채팅으로 보입니다.\n\n${list}\n\n이 채팅들은 빈 채팅으로 보관됩니다. 비활성화할까요?`,
  deactivateCharacterFailed: "비활성화에 실패했습니다: ",
  archiveSavePending: "비활성화했지만 아직 서버에 저장하지 못했습니다. 자동으로 다시 저장을 시도합니다.",
  bulkArchiveBusy: "이미 여러 캐릭터를 처리하는 중입니다. 끝난 뒤 다시 시도하세요.",
  bulkArchiveProgress: (done: number, total: number, trash: boolean) =>
    `${trash ? "휴지통으로 옮기는 중" : "비활성화하는 중"}… ${done}/${total}`,
  bulkArchiveDone: (count: number, trash: boolean) =>
    trash ? `캐릭터 ${count}개를 휴지통으로 옮겼습니다.` : `캐릭터 ${count}개를 비활성화했습니다.`,
  bulkArchiveFailed: (done: number, failed: number, list: string) =>
    `${done}개는 처리했고 ${failed}개는 실패했습니다. 실패한 캐릭터는 그대로 남아 있습니다.\n\n${list}`,
  bulkArchiveStopped: "변경사항을 서버에 저장하지 못해 나머지 캐릭터는 처리하지 않았습니다. 이미 처리한 캐릭터는 자동으로 다시 저장을 시도합니다.",
  bulkDeactivateLostChats: (count: number, list: string) =>
    `캐릭터 ${count}개에 서버에도 이 브라우저에도 내용이 없는 채팅이 있습니다. 열면 빈 채팅으로 보이는 채팅입니다.\n\n${list}\n\n이 채팅들은 빈 채팅으로 보관됩니다. 이 캐릭터들도 비활성화할까요?`,
  archiveSaveFailed: "최근 변경사항을 서버에 저장하지 못해, 변경사항을 지키기 위해 중단했습니다. 잠시 후 다시 시도하세요.",
  rebaseSkippedArchived: (names: string) =>
    `"${names}" 캐릭터가 다른 기기에서 비활성화되어 이 기기의 저장되지 않은 변경을 반영하지 못했습니다.`,
  activateCharacterConfirm: (name: string) => `"${name}" 캐릭터가 비활성화되어 있습니다. 활성화할까요?`,
  activateCharacterMissing: "보관된 캐릭터 데이터를 찾을 수 없어 활성화할 수 없습니다. 서버 로그와 스토리지 대시보드를 확인하세요.",
  activateCharacterFailed: "활성화에 실패했습니다: ",
  activateCharacterAlreadyActive: "서버에서 이 캐릭터가 이미 활성 상태입니다. 페이지를 새로고침하세요.",
  activateCharacterRemoveStub: "이 캐릭터를 목록에서 제거할까요? (다른 데이터는 삭제되지 않습니다)",
  deactivatedBadge: "비활성화",
  exportCharacter: "캐릭터 엑스포트",
  characterPackage: "캐릭터 패키지",
  characterPackageExport: "패키지 내보내기",
  convertToModule: "모듈로 변환",
  convertToCharacter: "캐릭터로 변환",
  successfullyConverted: "변환되었습니다.",
  characterPackageImport: "캐릭터 패키지 임포트 (zip)",
  characterPackageCharacter: "캐릭터",
  characterPackageChats: "채팅",
  characterPackagePersona: "페르소나",
  characterPackageInlays: "인레이 삽화",
  characterPackageNone: "없음",
  characterPackageChatCount: "개",
  characterPackageInlayCount: "장",
  characterPackageExportSuccess: "캐릭터 패키지를 성공적으로 내보냈습니다.",
  characterPackageImportSuccess: "캐릭터 패키지를 성공적으로 가져왔습니다.",
  characterPackageImportSummary: "패키지 내용",
  characterPackageInvalidZip: "유효하지 않은 캐릭터 패키지 파일입니다.",
  characterPackageProgressCharacter: "캐릭터 생성 중...",
  characterPackageProgressChats: "채팅 저장 중...",
  characterPackageProgressPersona: "페르소나 저장 중...",
  characterPackageProgressInlays: "인레이 저장 중",
  characterPackageProgressFinalizing: "마무리 중...",
  characterPackageProgressReading: "패키지 읽는 중...",
  characterPackageProgressImportChar: "캐릭터 가져오는 중...",
  characterPackageProgressImportPersona: "페르소나 가져오는 중...",
  characterPackageProgressImportChats: "채팅 가져오는 중...",
  characterPackageProgressImportInlays: "인레이 가져오는 중",
  characterPackageEmpty: "빈 껍데기",
  characterPackageEmptyWarning:
    "캐릭터 데이터가 비어 있습니다. 그래도 임포트할까요?",
  characterPackageNameMismatch: "캐릭터 이름이 다릅니다. 그래도 임포트할까요?",
  characterPackageImportToChar: "캐릭터에 패키지 불러오기",
  characterPackageLicenseWarning:
    "라이선스 정책으로 캐릭터를 내보낼 수 없습니다",
  characterPackageCheckCount: "확인",
  userSetting: "유저 설정",
  username: "유저 이름",
  userIcon: "유저 아이콘",
  successExport: "성공적으로 엑스포트하여 다운로드 경로에 다운로드했습니다.",
  successImport: "성공적으로 임포트했습니다.",
  moduleCreated: "모듈이 생성되었습니다.",
  moduleUpdated: "모듈이 수정되었습니다.",
  moduleDeleted: "모듈이 삭제되었습니다.",
  importedCharacter: "성공적으로 임포트 됨.",
  alwaysActive: "언제나 활성화",
  additionalPrompt: "추가 프롬프트",
  descriptionPrefix: "캐릭터 설명 Prefix",
  forceReplaceUrl: "리버스 프록시",
  emotionWarn: "채팅 분석에는 보조 모델을 사용합니다.",
  plugin: "플러그인",
  language: "언어",
  UiLanguage: "UI 언어",
  createfromScratch: "새 캐릭터 생성",
  importCharacter: "캐릭터 임포트",
  translator: "번역기",
  disabled: "비활성화됨",
  noPluginSelected: "플러그인이 선택되었지만, 플러그인이 없습니다.",
  text: "텍스트",
  UISize: "채팅 텍스트 크기",
  newVersion: "업데이트가 발견되었습니다. 설치하시겠습니까?",
  updateAvailable: "v{{version}} 업데이트 가능",
  updateRequired: "v{{version}} 필수 업데이트",
  updateOutdated: "v{{version}} — 현재 버전이 너무 오래되었습니다",
  statsUsersToday: "오늘 {{count}}명",
  statsYesterday: "어제 {{count}}명",
  statsVisitsToday: "오늘 방문 {{count}}회",
  updatePopupTitle: "업데이트 안내",
  updatePopupTitleRequired: "필수 업데이트",
  updatePopupTitleOutdated: "버전 만료",
  updatePopupDesc:
    "새 버전 <b>v{{latest}}</b>를 사용할 수 있습니다. (현재: v{{current}})",
  updatePopupViewRelease: "릴리스 보기",
  updatePopupLater: "나중에",
  selfUpdateNow: "지금 업데이트",
  selfUpdateInProgress: "업데이트 중...",
  selfUpdateDone: "업데이트 완료",
  selfUpdateFailed: "업데이트 실패",
  selfUpdateReloadHint: "새 버전을 적용하려면 페이지를 새로고침하세요.",
  selfUpdateReload: "새로고침",
  close: "닫기",
  remindLaterQuestion: "며칠 뒤에 다시 알려드릴까요?",
  remindIgnore: "무시",
  remindLater1Day: "1일 뒤에 다시 알림",
  remindLater3Days: "3일 뒤에 다시 알림",
  remindLater5Days: "5일 뒤에 다시 알림",
  remindLater1Week: "1주일 뒤에 다시 알림",
  display: "디스플레이",
  useCustomBackground: "커스텀 배경",
  translateInput: "입력창 번역하기",
  autoTranslation: "자동 번역",
  fullscreen: "전체화면(비권장)",
  playMessage: "메시지 소리 출력",
  iconSize: "아이콘 크기",
  single: "싱글",
  multiple: "멀티플",
  useCharLorebook: "캐릭터에 있는 로어 사용",
  selectChar: "캐릭터 선택",
  askLoadFirstMsg: "첫 메세지를 불러올까요?",
  theme: "테마",
  editOrder: "캐릭터 순서 변경",
  submodel: "보조 모델",
  timeOutinSec: "타임아웃 (초)",
  emotionPrompt: "감정 프롬프트",
  singleView: "싱글",
  SpacedView: "멀티플",
  emphasizedView: "더블",
  pluginWarn: "악성 플러그인 설치 시 문제가 생길 수 있습니다.",
  pluginConfirm:
    "이 플러그인을 정말로 가져오시겠습니까? 신뢰할 수 있는 출처의 플러그인만 가져오세요.",
  pluginContainsExternalMedia:
    "이 플러그인에는 외부 미디어가 포함되어 있습니다.",
  pluginContainsExternalJS:
    "이 플러그인에는 외부 자바스크립트가 포함되어 있습니다.",
  waifuWidth: "Waifu 채팅창 넓이",
  files: "파일",
  backupConfirm: "정말로 백업을 저장하시겠습니까?",
  backupLoadConfirm:
    "정말로 백업을 불러오시겠습니까? 현재 데이터가 모두 사라집니다!",
  backupLoadConfirm2:
    "정말로, 정말로 백업을 불러오시겠습니까? 현재 데이터가 모두 사라집니다!",
  others: "기타",
  sectionInterface: "인터페이스",
  sectionHomeList: "홈 / 채팅 목록",
  sectionChatView: "채팅 화면",
  sectionBubble: "말풍선 스타일",
  sectionQuotes: "따옴표",
  sectionAdvanced: "고급",
  accTabEditing: "편집",
  accTabScroll: "스크롤",
  accTabSidebar: "사이드바",
  presets: "프리셋",
  themePresets: "테마 프리셋",
  imageGeneration: "이미지 생성",
  provider: "공급자",
  key: "키",
  noData: "데이터 없음",
  currentImageGeneration: "현재 이미지 생성 데이터",
  promptPreprocess: "프롬프트 선보정 사용",
  SwipeRegenerate: "스와이프 리롤 사용",
  removeMessageOnly: "이 메시지만 삭제",
  removeMessageAndAfter: "이후 메시지까지 삭제 ({}개)",
  messageRemoved: "메시지 삭제됨",
  messagesRemoved: "메시지 {}개 삭제됨",
  confirmReroll: "메시지 재생성 시 확인",
  textColor: "텍스트 색상",
  classicRisu: "클래식 Risu",
  highcontrast: "고대비",
  requestretrys: "실패 시 재요청 횟수",
  utilityBot: "유틸리티 봇",
  waifuWidth2: "Waifu 캐릭터 크기",
  nodeOnlyStandardChatWidth: "채팅창 가로폭",
  chatWidthStandard: "표준",
  chatWidthWide: "넓게",
  chatWidthFull: "제한 없음",
  customCSSWarning:
    "PocketRisu는 원본 RisuAI와 UI 구성(HTML/CSS)이 다르기 때문에, 기존에 쓰던 커스텀 CSS가 레이아웃을 깨거나 의도와 다르게 동작할 수 있습니다. 어떤 부분을 덮어쓰는지 정확히 아는 경우에만 사용하세요.",
  customHTMLWarning:
    "PocketRisu는 원본 RisuAI와 UI 구성(HTML/CSS)이 다르기 때문에, 기존에 쓰던 커스텀 Chat HTML이 정상적으로 렌더되지 않을 수 있습니다. 어떤 부분을 덮어쓰는지 정확히 아는 경우에만 사용하세요.",
  sayNothing: "어떤 문자열도 입력되지 않을 시 'say nothing' 입력",
  regexScript: "정규식 스크립트",
  type: "타입",
  editInput: "입력문 수정",
  editOutput: "출력문 수정",
  editProcess: "리퀘스트 데이터 수정",
  loadLatest: "가장 최근 백업 불러오기",
  loadOthers: "다른 백업 불러오기",
  exampleMessage: "예시 대화",
  creatorNotes: "제작자 코멘트",
  systemPrompt: "시스템 프롬프트",
  characterNotes: "캐릭터 노트",
  personality: "성격",
  scenario: "시나리오",
  alternateGreetings: "추가 첫 메시지",
  unrecommended: "비권장",
  chatNotes: "채팅 노트",
  showUnrecommended: "비권장 설정 보이기",
  streamingDisplayOptimizationMode: "스트리밍 표시 최적화",
  streamingDisplayOptimizationOff: "끄기 (매 토큰 갱신)",
  streamingDisplayOptimizationOffDesc: "토큰이 올 때마다 화면을 갱신하고 스크립트를 처리합니다",
  streamingDisplayOptimizationBalanced: "0.1초 간격 갱신",
  streamingDisplayOptimizationBalancedDesc: "화면 갱신을 0.1초 단위로 묶어 부하를 낮춥니다",
  streamingDisplayOptimizationStrong: "완료 후 일괄 적용",
  streamingDisplayOptimizationStrongDesc: "스트리밍 중엔 원문만 표시하고, 완료되면 스크립트를 한 번에 적용합니다",
  allowV2Plugin: "비권장 V2.0 플러그인 허용",
  allowV21Plugin: "비권장 V2.1 플러그인 설치 허용",
  altGreet: "추가 첫 메시지",
  scripts: "스크립트",
  settings: "설정",
  selective: "멀티플 키",
  SecondaryKeys: "두번째 키",
  useGlobalSettings: "글로벌 설정 사용",
  recursiveScanning: "재귀 검색",
  creator: "제작자",
  CharVersion: "캐릭터 버전",
  Speech: "음성",
  useExperimental: "실험적 요소 보이기",
  showMemoryLimit: "기억 한계치 보이기",
  showFirstMessagePages: "퍼스트 메시지 페이지 보이기",
  roundIcons: "둥근 아이콘",
  streaming: "스트리밍",
  chatBot: "채팅 봇",
  modelPresetMenu: "모델 프리셋",
  promptPresetMenu: "프롬프트",
  botSettingsLegacyTitle: "[채팅 봇]은 구버전 기능입니다",
  botSettingsLegacyDesc: "최신 모델 업데이트가 지연되거나 새 기능이 적용되지 않을 수 있습니다. 최신화된 모델과 기능을 사용하려면 [모델 프리셋]을 이용하세요.",
  botSettingsPresetMovedDesc: "프리셋은 [프롬프트] 메뉴로 이전되었습니다.",
  botSettingsParamScopeDesc: "이 페이지의 파라미터는 [채팅 봇]에서 선택한 모델에만 적용됩니다. 모델 프리셋을 사용 중이라면 해당 프리셋 안에서 파라미터를 수정하세요.",
  botSettingsCustomFlagsScopeDesc: "커스텀 플래그 설정은 레거시 모델에서만 동작합니다. 모델 프리셋에는 모델 프로필에 맞게 자동으로 적용됩니다.",
  currentThemePreset: "현재 테마 프리셋",
  currentPromptPreset: "현재 프롬프트 프리셋",
  presetDuplicate: "복제하기",
  presetExport: "내보내기",
  presetImport: "불러오기",
  presetNew: "새 프리셋",
  presetManage: "프리셋 관리",
  moduleManage: "모듈 관리",
  pluginImport: "플러그인 임포트",
  pluginDevTools: "개발자 도구",
  presetDelete: "삭제하기",
  presetDuplicated: "프리셋을 복제했습니다",
  presetExported: "프리셋을 내보냈습니다",
  presetImported: "프리셋을 불러왔습니다",
  presetDeleted: "프리셋을 삭제했습니다",
  presetDeleteConfirm: "이 프리셋을 삭제하시겠습니까?",
  recoveredPresetName: "복구된 프리셋",
  recoveredPresetNotice: "선택된 프롬프트 프리셋을 찾을 수 없어 현재 설정을 '복구된 프리셋'으로 저장했습니다.",
  iconRemove: "아이콘 삭제",
  otherBots: "기타 봇",
  user: "유저",
  additionalAssets: "추가 에셋",
  viewInAssetViewer: "에셋 뷰어로 보기",
  editDisplay: "디스플레이 수정",
  textBackgrounds: "커스텀 채팅창 색깔",
  textBorder: "텍스트 윤곽선",
  textScreenRound: "둥근 채팅창",
  textScreenBorder: "채팅창 윤곽선",
  ttsReadOnlyQuoted: "따옴표 안 텍스트만 읽기",
  ttsStop: "TTS 중지",
  replaceGlobalNote: "글로벌 노트 덮어쓰기",
  charLoreBook: "캐릭터 로어북",
  globalLoreBook: "글로벌 로어북",
  globalRegexScript: "글로벌 정규식",
  accessibility: "접근성",
  sendWithEnter:
    "엔터키로 메세지 보내기(체크 해제시 Shift + Enter가 메세지 전송으로 변경.)",
  sendKeyPC: "메시지 보내기 키 (PC)",
  sendKeyMobile: "메시지 보내기 키 (모바일)",
  chatInputExpandTitle: "메세지 입력",
  resendLastMessage: "마지막 메세지를 재전송하기",
  enterMessagePlaceholder: "메세지를 입력하세요...",
  enterMessageToPersona: (name: string) => `${name}(으)로 메세지 보내기`,
  sendKeyEnter: "Enter (Shift+Enter로 줄바꿈)",
  sendKeyCtrlEnter: "Ctrl+Enter (Enter로 줄바꿈)",
  sendKeyShiftEnter: "Shift+Enter (Enter로 줄바꿈)",
  sendKeyButton: "전송 버튼만 사용 (Enter로 줄바꿈)",
  fixedChatTextarea: "채팅 입력창 하단 고정",
  clickToEdit: "클릭해서 수정하기",
  enableBlockPartialEdit:
    "블록 부분 수정 활성화 (블록에 마우스를 올려 개별 수정)",
  enableDragPartialEdit: "드래그 부분 수정 활성화 (텍스트 선택 후 수정)",
  setNodePassword: "보안을 위해 비밀번호를 정해주세요",
  inputNodePassword:
    "비밀번호를 입력해주세요. 기억이 안나신다면, save/__password를 지우고 서버를 재시작해주세요.",
  simple: "간단",
  advanced: "고급",
  askReRollAutoSuggestions: "자동 제안 다시 뽑기",
  creatingSuggestions: "응답 제안 작성 중...",
  active: "활성화",
  loreRandomActivation: "확률 조건 사용",
  activationProbability: "발동 확률",
  hub: "RisuRealm",
  tags: "태그",
  backgroundHTML: "백그라운드 임베딩",
  copied: "복사됨",
  useChatCopy: "채팅 메시지 복사 사용",
  useChatSticker: "채팅 스티커 사용",
  useAdditionalAssetsPreview: "추가 에셋 미리보기 사용",
  autoTranslateInput: "입력 자동 번역",
  enterMessageForTranslateToEnglish: "영어로 번역할 메시지를 입력해주세요",
  recent: "최근",
  downloads: "다운로드",
  trending: "인기",
  imageCompression: "이미지 압축",
  inlayImageLossless: "인레이 이미지(삽화) 압축 없이 저장",
  inlayImagePriority: "인레이 이미지(삽화) 우선 렌더링",
  inlayCompressAll: "전체 인레이 이미지(삽화) 압축",
  inlayCompressing: "압축 중...",
  inlayCompressConfirm:
    "모든 인레이 이미지를 WebP로 압축합니다. 되돌릴 수 없습니다. 계속하시겠습니까?",
  inlayCompressDone: "압축 완료",
  inlayCompressCount: "개 이미지 압축",
  saved: "절감",
  notLoggedIn: "Risu Account에 로그인되지 않음",
  SaveDataInAccount: "계정에 데이터 저장",
  dataSavingInAccount: "계정에 데이터 저장 중",
  logout: "로그아웃",
  loadDataFromAccount: "계정에서 데이터 불러오기",
  saveCurrentDataToAccount: "계정에 데이터 현재 덮어쓰기",
  chatAssumed: "",
  proxyAPIKey: "키/패스워드",
  proxyRequestModel: "요청 모델",
  officialWiki: "공식 위키",
  officialWikiDesc: "리스AI의 공식 위키. 자유롭게 보세요.",
  officialDiscord: "공식 디스코드",
  officialDiscordDesc: "리스AI에 대해 자유롭게 대화하세요.",
  persona: "페르소나",
  personaSearch: "이름 또는 메모로 검색",
  personaManage: "페르소나 관리",
  memoryPresetDefault: "기본 프리셋",
  memoryBindingLabel: "장기기억 바인딩",
  memoryPresetOff: "사용 안 함",
  memoryPresetInherit: "기본값",
  memoryPresetSetDefault: "기본으로 설정",
  memoryPresetCreate: "새 프리셋",
  memoryPresetSearch: "프리셋 이름으로 검색",
  memoryPresetMethod: "방식",
  memoryPresetName: "프리셋 이름",
  memoryPresetManage: "장기기억 관리",
  memoryPresetLastOne: "프리셋은 최소 하나 있어야 합니다.",
  memoryPresetBound: "장기기억 프리셋이 변경되었습니다.",
  folderUncategorized: "미분류",
  folderNew: "새 폴더",
  folderMoveTo: "폴더로 이동",
  folderDeleteKeepItems: "이 폴더를 삭제할까요? 폴더 안의 항목은 미분류로 이동합니다.",
  moveUp: "위로",
  moveDown: "아래로",
  icon: "아이콘",
  account: "계정",
  remove: "삭제",
  able: "활성화됨",
  assetWidth: "에셋 넓이",
  animationSpeed: "에니메이션 속도",
  screenshot: "스크린샷",
  screenshotSaved: "스크린샷 저장됨",
  createBotwithAI: "AI로 캐릭터 생성하기",
  changeFolderName: "변경할 폴더 이름을 입력해주세요.",
  cancel: "취소",
  renameFolder: "폴더 이름 변경하기",
  changeFolderColor: "폴더 색상 변경하기",
  changeFolderImage: "폴더 이미지 변경하기",
  fullWordMatching: "단어 단위 매칭",
  botSettingAtStart: "실행 시 봇 설정으로 시작하기",
  triggerStart: "채팅 보낼 시",
  triggerInput: "유저 입력 시",
  triggerOutput: "봇 출력 시",
  triggerManual: "수동 트리거",
  triggerCondVar: "만약 변수",
  triggerCondExists: "만약 채팅에 텍스트 존재",
  triggerScript: "트리거 스크립트",
  triggerMatchRegex: "정규식 매칭",
  triggerMatchLoose: "느슨한 매칭",
  triggerMatchStrict: "정확한 매칭",
  searchDepth: "검색 깊이",
  equal: "같다면",
  notEqual: "같지 않다면",
  greater: "보다 크다면",
  less: "보다 작다면",
  greaterEqual: "크거나 같다면",
  lessEqual: "작거나 같다면",
  triggerEffSysPrompt: "시스템 프롬프트 추가",
  triggerEffSetVar: "변수 변경",
  triggerEffImperson: "채팅 보내기",
  triggerEffCommand: "커맨드 실행",
  triggerEffRunTrigger: "트리거 실행",
  triggerEffStop: "프롬프트 중지",
  triggerEffCall: "트리거 호출",
  varableName: "변수 이름",
  role: "역할",
  location: "위치",
  promptstart: "프롬프트 시작",
  promptend: "프롬프트 끝",
  historyend: "채팅 끝",
  always: "언제나",
  noEffect: "효과 없음",
  invaildTriggerEffect: "이 효과는 이 트리거 타입에 사용할 수 없습니다.",
  operator: "연산자",
  TriggerSetToVar: "변수에 설정",
  TriggerAddToVar: "변수에 더하기",
  TriggerSubToVar: "변수에서 빼기",
  TriggerMulToVar: "변수에 곱하기",
  TriggerDivToVar: "변수에 나누기",
  isNull: "값이 없다면",
  ifChatIndex: "채팅 인덱스가",
  ifRandom: "만약 랜덤",
  ifValue: "값이 다음과 같다면",
  hideRealm: "RisuRealm 접힘으로 시작",
  blockRealmCreator: "제작자 차단",
  blockRealmCreatorConfirm: "{{creator}} 제작자의 모든 RisuRealm 콘텐츠를 차단할까요?",
  realmCreatorBlocked: "차단한 RisuRealm 제작자의 콘텐츠이므로 이용할 수 없습니다.",
  realmCreatorBlockedSuccess: "제작자를 차단했습니다.",
  manageBlockedRealmCreators: "차단한 제작자 관리",
  blockedRealmCreators: "차단한 RisuRealm 제작자",
  noBlockedRealmCreators: "차단한 RisuRealm 제작자가 없습니다.",
  unblockRealmCreator: "차단 해제",
  hideAllImages: "모든 이미지 숨기기",
  hideMessagePageCount: "메세지 페이지 숫자 숨기기",
  popularityLevel: "{} 인기도",
  colorScheme: "색상 팔레트",
  colorSchemeDefault: "기본값",
  showLegacyColorSchemes: "구버전 팔레트 보이기",
  rangeStart: "범위 시작",
  rangeEnd: "범위 끝",
  untilChatEnd: "채팅 끝까지",
  usePromptTemplate: "프롬프트 템플릿 사용",
  specialType: "특수 타입",
  noSpecialType: "특수 타입 없음",
  forceProxyAsOpenAI: "OpenAI 포맷으로 강제",
  promptTemplate: "프롬프트 템플릿",
  customInnerFormat: "커스텀 내부 포맷",
  innerFormat: "내부 포맷",
  HypaMemory: "하이파메모리",
  ToggleHypaMemory: "하이파 메모리 켜기",
  resetPromptTemplateConfirm: "정말로 프롬프트 템플릿을 초기화하시겠습니까?",
  emotionMethod: "감정 방식",
  continueResponse: "응답 계속하기",
  showMenuChatList: "메뉴에서 채팅 리스트 보이기",
  translatorLanguage: "번역기 언어",
  translatorType: "번역기 타입",
  htmlTranslation: "HTML 번역",
  deeplKey: "deepL API 키",
  deeplFreeKey: "deepL 무료 API 키",
  deeplXUrl: "deepLX URL",
  deeplXToken: "deepLX Token",
  exportPersona: "페르소나 엑스포트",
  importPersona: "페르소나 임포트",
  export: "엑스포트",
  import: "임포트",
  useNamePrefix: "이름을 프리픽스로 사용",
  textAdventureNAI: "텍스트 어드벤쳐로 실행",
  appendNameNAI: "NAI에서 이름을 텍스트 뒤에 붙이기",
  customStopWords: "커스텀 정지 단어",
  defaultPrompt: "기본 프롬프트",
  additionalText: "추가 디스크립션",
  seed: "시드",
  charjs: "캐릭터JS",
  depthPrompt: "깊이 프롬프트",
  largePortrait: "세로 이미지",
  reverseProxyOobaMode: "Ooba 모드",
  exactTokens: "정확 토큰",
  fixedTokens: "대략적 토큰",
  inlayViewScreen: "인레이 스크린",
  imgGenPrompt: "이미지 생성 프롬프트",
  imgGenNegatives: "이미지 생성 네거티브 프롬프트",
  imgGenInstructions: "이미지 생성 지시사항",
  usePlainFetchWarn:
    "NovelAI 사용 시 CORS 오류가 발생할 수 있으므로, NovelAI를 사용할 때는 이 옵션을 비활성화해 주세요.",
  translationPrompt: "번역 프롬프트",
  translationResponseSize: "번역 응답 크기",
  webdeeplwarn: "이 옵션은 웹에서는 제대로 작동하지 않을 수 있습니다.",
  saveBackupLocal: "로컬 백업 저장",
  saveBackupForUpstream: "원본 리스용 백업 내보내기",
  saveBackupForUpstreamConfirm:
    "이 백업은 원본 RisuAI(웹·Tauri)로 데이터를 옮기기 위한 용도입니다. 인레이 이미지는 entry 이름 형식이 원본 RisuAI 임포트와 호환되지 않아 제외됩니다. 그 외 데이터(데이터베이스, 캐릭터 에셋, 콜드 스토리지)는 포함됩니다.\n\n포켓리스 사이의 데이터 이동에는 일반 로컬 백업을 사용하세요.\n\n계속하시겠습니까?",
  loadBackupLocal: "로컬 백업 불러오기",
  topP: "Top P",
  genTimes: "생성 횟수",
  cot: "생각의 사슬",
  forcePlainFetch: "직접 요청 보내기",
  autoFillRequestURL: "요청 URL 자동 채우기",
  newOAIHandle: "새로운 OpenAI 방식 적용",
  inlayImage: "인레이 이미지",
  nativeAutomark: "실험적 네이티브 오토마크 사용",
  assistantPrefill: "어시스턴트 프리필",
  postEndInnerFormat: "엔드 뒤 프롬프트",
  sendChatAsSystem: "시스템으로 채팅 보내기",
  sendName: "그룹챗 밖에서도 이름 붙이기",
  utilOverride: "유틸리티 덮어쓰기",
  template: "템플릿",
  chatAsOriginalOnSystem: "기존 역할로 보내기",
  exportAsDataset: "데이터셋으로 세이브 엑스포트",
  editTranslationDisplay: "번역문 수정",
  selectModel: "모델 선택",
  autoRemoveThoughtTag: "Thought 태그 자동 제거",
  customChainOfThought: "커스텀 생각의 사슬",
  maxThoughtTagDepth: "Thought 태그 최대 깊이",
  openRouterFallback: "폴백 사용",
  openRouterMiddleOut: "미들 아웃 사용",
  openRouterProviderOrder: "제공자 선호 순서",
  openRouterProviderOnly: "허용할 제공자",
  openRouterProviderIgnore: "무시할 제공자",
  openRouterSearchModel: "모델 검색...",
  openRouterSortByName: "이름 순",
  openRouterSortByPrice: "가격 순",
  openRouterSortByProvider: "회사 순",
  openRouterSortAsc: "오름차순",
  openRouterSortDesc: "내림차순",
  geminiApiKey: "Gemini API Key",
  memoryLimitThickness: "기억 한계선 두께",
  inputCardPassword: "카드 비밀번호 입력",
  ccv2Desc: "Character Card V2은 챗봇 프로그램에서 자주 사용되는 포맷입니다.",
  ccv3Desc: "Character Card V3은 발전된 기능을 제공하는 포맷입니다.",
  rccDesc: "미사용",
  password: "비밀번호",
  license: "라이센스",
  licenseDesc:
    "라이센스는 다른 사용자가 이 캐릭터를 사용할 수 있는지 결정합니다.",
  passwordDesc: "비밀번호를 설정하여 다른 사용자의 접근을 제한할 수 있습니다.",
  largePersonaPortrait: "페르소나 세로 이미지",
  module: "모듈",
  modules: "모듈",
  noModules: "모듈이 없습니다.",
  createModule: "모듈 생성",
  basicInfo: "기본 정보",
  moduleContent: "모듈 내용",
  confirmRemoveModuleFeature: "정말로 이 기능을 삭제하시겠습니까?",
  editModule: "모듈 수정",
  importModule: "모듈 임포트",
  download: "다운로드",
  edit: "수정",
  enableGlobal: "글로벌 활성화",
  chatModulesInfo:
    "모듈을 이 채팅 또는 이 캐릭터 한정으로 활성화/비활성화합니다. 말풍선 버튼은 채팅, 사람 버튼은 캐릭터입니다. 지구본이 표시된 모듈은 전역으로 켜져 있어 모든 채팅에 적용되며, 설정 > 모듈에서 바꿀 수 있습니다.",
  moduleScopeChat: "이 채팅에서 사용",
  moduleScopeCharacter: "이 캐릭터에서 사용",
  moduleScopeGlobal: "전역 활성화됨. 설정 > 모듈에서 변경",
  sideMenuRerollButton: "사이드 메뉴 리롤 버튼",
  persistentStorage: "영구 저장소",
  persistentStorageSuccess: "저장소가 영구적으로 설정되었습니다.",
  persistentStorageFail:
    "저장소 설정에 실패했습니다. 브라우저에서 거부되었을 수 있습니다.",
  persistentStorageRecommended: "영구 저장소 권장됨",
  unsupportedFileType: "지원하지 않는 파일 형식입니다",
  persistentStorageDesc:
    "당신의 브라우저는 영구 저장소를 지원합니다. 이 기능을 활성화하면, 데이터가 브라우저에 더 오래 남습니다.",
  enable: "활성화",
  postFile: "파일 업로드",
  requestInfoInsideChat: "채팅 내부에서 요청 정보 보이기",
  inputTokens: "입력 토큰",
  outputTokens: "출력 토큰",
  tokenWarning:
    "토큰 계산은 정확하지 않을 수 있습니다. 참고용으로만 사용해주세요.",
  log: "로그",
  popularityLevelDesc:
    "인기도는 이 캐릭터가 얼마나 인기 있는지를 나타냅니다. 여러가지 요소가 영향을 미칩니다.",
  additionalParams: "추가 파라미터",
  additionalParamsHelp:
    "한 줄에 하나씩. `key=value` / `key=json::{...}` / `header::Name=value` / `key={{none}}` 지원.",
  tokenizerOverride: "토크나이저 오버라이드",
  tokenizerOverrideHelp:
    "토큰 계산용. 자동으로 두면 프로필 권장값을 사용합니다.",
  tokenizerAuto: "자동",
  heightMode: "높이 모드",
  useAdvancedEditor: "고급 에디터 사용",
  noWaitForTranslate: "번역 기다리지 않기",
  antiClaudeOverload: "Claude 오버로드 방지",
  activeTabChange:
    "현재 탭이 비활성화되었습니다. OK를 누르면 탭이 다시 활성화됩니다.",
  sessionHandoffReload:
    "다른 기기에서 사용되어 최신 상태로 새로고침했어요.",
  sessionUnsavedTitle: "다른 곳에서 저장 권한을 가져갔어요",
  sessionUnsavedDetail:
    "이 탭의 저장은 멈췄고, 아직 서버에 저장되지 않은 편집이 있어요. 새로고침하면 그 편집은 사라지고 최신 상태를 불러옵니다. 먼저 미저장 편집을 JSON 파일로 내려받아 두면 필요한 내용을 직접 옮겨 적을 수 있어요.",
  sessionUnsavedDownload: "미저장 편집 내려받기",
  sessionUnsavedReload: "편집을 버리고 새로고침",
  sessionUnsavedPaused: "이 탭의 저장은 멈춘 상태예요. 편집 내용을 옮긴 뒤 새로고침하세요.",
  backupBrowserDownloadStarted: "브라우저 다운로드로 백업을 받기 시작했어요. 진행 상황과 완료는 브라우저의 다운로드 목록에서 확인하세요.",
  addCharacter: "캐릭터 추가",
  importFromRealm: "RisuRealm에서 고르기",
  importFromRealmDesc:
    "여러 캐릭터들이 공유된 RisuRealm에서 캐릭터를 고르세요.",
  random: "랜덤",
  metaData: "메타데이터",
  autoContinueMinTokens: "타겟 토큰 (자동 컨티뉴)",
  autoContinueChat: "불완전 문단 방지 (자동 컨티뉴)",
  removeIncompleteResponse: "불완전 문단 제거",
  tokenizer: "토크나이저",
  chatFormating: "채팅 포맷",
  useInstructPrompt: "인스트럭트 프롬프트 사용",
  textAreaSize: "입력 영역 크기",
  textAreaTextSize: "입력 텍스트 크기",
  sideBarSize: "사이드바 크기",
  embedding: "임베딩",
  syntax: "문법",
  run: "실행",
  noMessage: "무언가 입력하여 채팅을 시작하세요.",
  combineTranslation: "결합 번역",
  dynamicAssets: "다이나믹 에셋",
  dynamicAssetsEditDisplay: "디스플레이 수정에 다이나믹 에셋 사용",
  longTermMemory: "장기기억",
  grid: "그리드",
  list: "리스트",
  trash: "휴지통",
  trashDesc:
    "휴지통의 캐릭터는 비활성화 상태로 서버에 보관되어 성능에 영향을 주지 않습니다. 자동으로 삭제되지 않으며, 언제든 복원하거나 영구 삭제할 수 있습니다.",
  shareExport: "공유/엑스포트",
  risupresetDesc:
    "Risupreset 포맷은 포맷을 공유하기 위한 PocketRisu 전용 포맷입니다.",
  risuMDesc: "RisuM 포맷은 PocketRisu 모듈을 위해 특별히 설계된 포맷입니다.",
  jsonDesc: "JSON은 데이터를 저장하고 불러오기 위한 일반적인 포맷입니다.",
  nickname: "닉네임",
  useRegexLorebook: "정규식 사용",
  customPromptTemplateToggle: "커스텀 토글",
  defaultVariables: "기본 변수",
  lowLevelAccess: "저수준 접근",
  resultStoredVar: "결과 저장 변수",
  triggerEffRunLLM: "메인 모델 실행",
  triggerEffectSendAI: "AI 재전송",
  triggerEffCheckSim: "유사성 확인",
  triggerEffShowAlert: "알림 보이기",
  normal: "일반",
  error: "에러",
  input: "입력",
  select: "선택",
  options: "선택지",
  alertContent: "알림 내용",
  lowLevelAccessConfirm:
    "이 컨텐츠는 저수준 접근을 사용합니다. 이는 이 컨텐츠가 AI 모델과 당신의 저장소에 직접 접근할 수 있음을 의미합니다. 이 컨텐츠를 정말로 임포트하시겠습니까?",
  triggerLowLevelOnly:
    "이 트리거는 저수준 접근만 사용할 수 있습니다. 이 트리거를 활성화하려면 캐릭터나 모듈의 고급 설정에서 저수준 접근을 활성화하세요.",
  truthy: "참",
  extractRegex: "정규식으로 텍스트 추출",
  runImgGen: "이미지 생성 실행",
  cutChat: "채팅 자르기",
  modifyChat: "채팅 수정",
  regex: "정규식",
  flags: "플래그",
  resultFormat: "결과 포맷",
  negPrompt: "부정 프롬프트",
  start: "시작",
  end: "끝",
  index: "인덱스",
  search: "검색",
  goCharacterOnImport: "임포트 시 캐릭터로 이동",
  format: "포맷",
  v2Warning:
    "주의: V2 카드는 더 이상 지원되지 않습니다. 일부 데이터가 누락될 수 있습니다.",
  applyModule: "모듈 적용",
  successApplyModule: "모듈이 성공적으로 적용되었습니다.",
  font: "폰트",
  lineHeight: "줄간격",
  loadAutoServerBackup: "자동 서버 백업 불러오기",
  notCharxWarn:
    "이 캐릭터는 여러 에셋을 사용합니다. 더 나은 호환성을 위해 이 캐릭터를 CharX 포맷으로 엑스포트하는 것이 좋습니다.",
  noPlugins: "설치된 플러그인이 없습니다.",
  legacyTranslation: "레거시 번역",
  clipboardSuccess: "클립보드에 복사됨",
  translateContent: "컨텐츠 번역",
  doNotTranslate: "번역하지 않음",
  includePersonaName: "페르소나 이름 포함",
  hidePersonaName: "페르소나 이름 숨기기",
  triggerSwitchWarn:
    "트리거 타입을 변경하면 현재 트리거가 손실됩니다. 계속하시겠습니까?",
  codeMode: "코드",
  blockMode: "블록",
  helpBlock: "도움말",
  hideChatIcon: "아이콘 UI 숨기기",
  loadInternalBackup: "내부 백업 불러오기",
  createCopy: "복사본 생성",
  copyChatConfirm: "복사본을 만드시겠습니까: ",
  copyChatSuccess: "채팅을 복사했어요",
  bindPersona: "페르소나 바인드",
  chatOptions: "채팅 옵션",
  doYouWantToBindCurrentPersona:
    "현재 페르소나를 이 채팅에 바인드하시겠습니까?",
  doYouWantToUnbindCurrentPersona:
    "페르소나를 이 채팅에서 언바인드하시겠습니까?",
  personaBindingLabel: "페르소나 바인딩",
  personaBindedSuccess: "페르소나가 성공적으로 바인드되었습니다.",
  personaUnbindedSuccess: "페르소나가 성공적으로 언바인드되었습니다.",
  personaBindChange: "페르소나 변경",
  personaBindUnbind: "바인딩 해제",
  personaBindCurrent: "현재 페르소나 바인딩",
  personaSelectOther: "다른 페르소나 선택",
  promptBindingLabel: "프롬프트 바인딩",
  promptPresetParamsUse: "프롬프트 파라미터 사용",
  promptPresetParamScopeDesc: "이 파라미터들은 프롬프트 프리셋에 저장됩니다. 클래식 모델 모드에서는 항상 적용되며, 모델 프리셋 사용 시에는 사이드바 프롬프트 바인딩에서 \"프롬프트 파라미터 사용\"을 켠 채팅에서만 샘플링 파라미터가 적용됩니다. 용량 설정(최대 콘텍스트/응답 크기)은 모델의 속성이므로 항상 모델 프리셋이 결정합니다.",
  promptBindedSuccess: "프롬프트 프리셋이 성공적으로 바인드되었습니다.",
  promptUnbindedSuccess: "프롬프트 프리셋이 성공적으로 언바인드되었습니다.",
  promptBindChange: "프롬프트 프리셋 변경",
  promptBindUnbind: "바인딩 해제",
  promptBindCurrent: "현재 프롬프트 바인딩",
  presetSelectOther: "다른 프롬프트 프리셋 선택",
  promptPresets: "프롬프트 프리셋",
  presetEdit: "수정하기",
  modelPresets: "모델 프리셋",
  modelPresetEmpty: "등록된 모델 프리셋이 없습니다",
  modelPresetCreate: "새 모델 프리셋 만들기",
  basicSettings: "기본 설정",
  backToList: "목록으로",
  selectProfile: "프로필 선택",
  searchProfiles: "프로필 검색",
  noProfileMatch: "일치하는 프로필이 없습니다",
  modelPresetCreated: "모델 프리셋이 생성되었습니다",
  profileStatusCurrent: "현재",
  profileStatusOutdated: "이전",
  profileStatusDeprecated: "지원 종료 예정",
  profileTabOfficial: "공식",
  profileTabCustom: "커스텀",
  profileImport: "프로필 가져오기",
  profileExport: "내보내기",
  profileDelete: "삭제",
  profileExportNoBase: "base provider를 찾을 수 없어 내보낼 수 없습니다.",
  profileImportParseError: "JSON 파싱에 실패했습니다.",
  profileImportInvalid: "프로필 형식이 올바르지 않습니다:",
  profileOverwriteConfirm: "같은 id의 커스텀 프로필이 이미 있습니다. 덮어쓸까요?",
  profileImported: "프로필을 가져왔습니다.",
  customProfileEmpty: "커스텀 프로필이 없습니다. 가져오기로 추가하세요.",
  profileReplace: "프로필 교체",
  profileReplaced: "프로필을 교체했습니다.",
  profileDataIncomplete: "이 프로필의 데이터가 불완전합니다. 모델 프리셋 메뉴를 다시 열어 레지스트리를 갱신한 뒤 다시 시도하세요.",
  profileUpdateAvailable: "업데이트 가능",
  profileSourceMissing: "원본 프로필 없음",
  profileSectionTitle: "프로필",
  profileUpdatedAtLabel: "현재 버전",
  profileLatestVersionLabel: "최신 버전",
  profileUpdateConfirm: "이 프로필로 업데이트할까요?",
  profileReplaceWarn: "이 프로필에 없는 설정은 사라집니다. 계속할까요?",
  profileUpdateLossWarn: "일부 정보가 유실될 수 있습니다. 계속할까요?",
  registryNoticeBanner: "모델 프로필 {n}개가 업데이트 되었어요.",
  registryNoticeMore: "더보기",
  registryNoticeTitle: "모델 프로필 업데이트",
  registryNoticeNewSection: "신규 모델",
  registryNoticeUpdatedSection: "업데이트 모델",
  registryNoticeDismiss: "이 변경은 다시 보지 않기",
  registryNoticeConfirm: "확인",
  apiKeyManagerMenu: "API 키 관리",
  apiKeyManagerDesc: "여러 프리셋에서 재사용할 API 키를 저장합니다.",
  apiKeyAdd: "키 추가",
  apiKeyName: "이름",
  apiKeyProvider: "프로바이더",
  apiKeyProviderUnset: "미지정",
  apiKeyValue: "API 키",
  apiKeyPoolEmpty: "저장된 키가 없습니다.",
  apiKeyModePool: "저장된 키",
  apiKeyModeDirect: "직접 입력",
  apiKeySelectNone: "선택 안 함",
  apiKeyDeletedOption: "삭제된 키",
  apiKeyShowAll: "모든 키 보기",
  apiKeySave: "이 키 저장",
  apiKeyFormSave: "저장",
  apiKeyNamePrompt: "저장할 키 이름을 입력하세요",
  parameters: "파라미터",
  sizeAndSpeed: "크기와 속도",
  useLegacyGUI: "레거시 GUI 사용",
  claudeCachingExperimental: "클로드 캐싱",
  openClose: "열기/닫기",
  hideApiKeys: "API 키 숨기기",
  unformatQuotes: "따옴표 포맷팅 비활성화",
  enableDevTools: "개발자 도구 활성화",
  selectFile: "파일 선택",
  namespace: "네임스페이스",
  moduleIntergration: "모듈 통합",
  previewInfo: "미리보기는 모델 특화 처리 전에 프롬프트를 보여줍니다.",
  miscTools: "기타 도구",
  promptConvertion: "프롬프트 변환",
  convertionStep1:
    "프롬프트와 관련된 모든 파일을 선택하세요 (컨텍스트, 인스트럭트, 샘플러 JSON을 지원합니다)",
  customCSS: "커스텀 CSS",
  betaMobileGUI: "모바일 GUI(비권장)",
  enableScrollToActiveChar: "활성 캐릭터로 스크롤 활성화",
  menu: "메뉴",
  jsonSchema: "JSON 스키마",
  enableJsonSchema: "스키마 활성화",
  strictJsonSchema: "엄격한 스키마",
  extractJson: "JSON 추출",
  reloadSession:
    "새로운 세이브 데이터 버전이 발견되었습니다. 세션을 다시 로딩 중...",
  fixMarkdownNewline: "마크다운 줄바꿈 수정",
  customQuotes: "커스텀 따옴표",
  leadingSingleQuote: "선행 단일 따옴표",
  leadingDoubleQuote: "선행 이중 따옴표",
  trailingSingleQuote: "후행 단일 따옴표",
  trailingDoubleQuote: "후행 이중 따옴표",
  translatorNote: "번역가의 노트",
  formatGroupInSingle: "그룹을 하나로 포맷",
  groupInnerFormat: "비화자 내부 포맷",
  chatHTML: "채팅 HTML",
  logShare: "공유 로그 버튼 보이기",
  preview: "미리보기",
  recommended: "추천",
  newChat: "새 채팅",
  predictedOutput: "출력 예측",
  systemContentReplacement: "시스템 포맷 교체",
  systemRoleReplacement: "시스템 역할 교체",
  seperateParameters: "파라미터 분리",
  seperateParametersEnabled: "파라미터 분리 활성화",
  summarizationPrompt: "요약 프롬프트",
  reSummarizationPrompt: "재요약 프롬프트",
  translatorPrompt: "번역 프롬프트",
  translateBeforeHTMLFormatting: "HTML 포맷 전 번역",
  retranslate: "다시 번역",
  editTranslation: "번역 수정",
  editTranslationSave: "번역 저장",
  exportTranslationCache: "번역 캐시 내보내기",
  exportTranslationCacheSuccess: "번역 캐시를 내보냈습니다.",
  importTranslationCache: "번역 캐시 가져오기",
  importTranslationCacheConfirm:
    "번역 캐시에 항목을 병합합니다. 기존 키는 덮어씌워집니다. 계속하시겠습니까?",
  importTranslationCacheSuccess: "번역 캐시 {0}개 항목을 가져왔습니다.",
  importTranslationCacheFailed:
    "{0}개 항목을 가져왔지만 {1}개 항목 저장에 실패했습니다. 저장 공간이 가득 찼을 수 있습니다.",
  exportTranslationCacheEmpty: "번역 캐시가 비어 있습니다.",
  clearTranslationCache: "번역 캐시 지우기",
  clearTranslationCacheSuccess: "번역 캐시를 모두 지웠습니다.",
  clearTranslationCacheConfirm:
    "모든 번역 캐시 항목이 삭제됩니다. 되돌릴 수 없습니다. 계속하시겠습니까?",
  loading: "로딩중",
  autoTranslateCachedOnly: "캐시된 메시지만 자동 번역",
  notification: "알림",
  permissionDenied: "브라우저 또는 OS에 의해 권한이 거부되었습니다",
  customFlags: "커스텀 플래그",
  enableCustomFlags: "커스텀 플래그 활성화",
  googleCloudTokenization: "Google Cloud 토큰화",
  presetChain: "프리셋 체인",
  legacyMediaFindings: "레거시 미디어 검색",
  staticsDisclaimer:
    "통계는 2024년 7월 이후의 데이터를 기반으로 하며, 정확하지 않을 수 있습니다.",
  subtitles: "자막",
  subtitlesWarning1:
    "이 기능을 사용하려면 오디오/비디오 입력을 지원하는 모델을 사용해야 합니다.",
  subtitlesWarning2:
    "이 기능을 사용하려면 스트리밍 기능을 지원하는 모델을 사용해야 합니다.",
  reset: "초기화",
  clearInputConfirm: "이 입력란의 내용을 모두 지울까요?",
  assetMaxDifference: "에셋 최대 차이",
  sourceLanguage: "원본 언어",
  destinationLanguage: "목표 언어",
  noWebGPU:
    "브라우저 또는 OS가 WebGPU를 지원하지 않습니다. 이로 인해 성능이 크게 저하될 수 있습니다.",
  menuSideBar: "메뉴 사이드바(비권장)",
  home: "홈",
  showSavingIcon: "저장 아이콘 표시",
  pluginVersionWarn:
    "이 플러그인은 {{plugin_version}} 버전입니다. 이 버전의 PocketRisu와 호환되지 않습니다. 플러그인을 {{required_version}} 버전으로 업데이트하세요.",
  imageTranslation: "이미지 번역",
  banCharacterset: "문자 집합으로 자동 재생성",
  realmDirectOpen: "RisuRealm 미리보기에서 바로 열기",
  showPromptComparison: "프롬프트 비교 보기",
  inlayErrorResponse: "인레이 오류 응답",
  triggerOn: "활성화 조건",
  noConfig: "설정 없음",
  varName: "변수 이름",
  var: "변수",
  condition: "조건",
  trigger: "트리거",
  outputVar: "출력 변수",
  source: "출처",
  cmd: "명령어",
  sysStart: "시스템 시작",
  sysHistoryEnd: "시스템 히스토리 끝",
  sysPromptEnd: "시스템 프롬프트 끝",
  target: "목표",
  addElse: "그 외에 경우 추가",
  min: "최소값",
  max: "최대값",
  delimiter: "구분자",
  deleteCount: "삭제 개수",
  triggerEffRunAxLLM: "보조 모델 실행",
  hypaV3Settings: {
    descriptionLabel:
      "HypaMemory V3는 요약과 벡터 검색을 모두 사용하는 장기 기억 시스템입니다.",
    supaMemoryPromptPlaceHolder: "기본값을 사용하려면 비워두세요",
    maxMemoryTokensRatioLabel: "최대 메모리 토큰 비율 (추정)",
    maxMemoryTokensRatioError: "최대 메모리 토큰 비율을 계산할 수 없습니다",
    memoryTokensRatioLabel: "메모리 토큰 비율",
    extraSummarizationRatioLabel: "추가 요약 비율",
    maxChatsPerSummaryLabel: "요약본당 최대 메시지 수",
    queryChatCountLabel: "쿼리 채팅 수",
    recentMemoryRatioLabel: "최근 메모리 비율",
    similarMemoryRatioLabel: "유사 메모리 비율",
    randomMemoryRatioLabel: "무작위 메모리 비율",
    enableSimilarityCorrectionLabel: "유사도 보정 활성화",
    preserveOrphanedMemoryLabel: "고아 메모리 보존",
    applyRegexScriptWhenRerollingLabel: "재생성 시 정규식 스크립트 적용",
    doNotSummarizeUserMessageLabel: "유저 메시지 요약하지 않기",
  },
  hypaV3Modal: {
    titleLabel: "HypaV3",
    resetConfirmMessage:
      "이 작업은 되돌릴 수 없습니다. HypaV3 데이터를 초기화하시겠습니까?",
    resetConfirmSecondMessage:
      "이 작업은 복구할 수 없습니다. 정말로, 정말로 HypaV3 데이터를 초기화하시겠습니까?",
    convertLabel:
      "아직 요약이 없지만, HypaV2 데이터를 V3로 변환할 수 있습니다.",
    convertButton: "V3로 변환",
    convertSuccessMessage: "HypaV2 데이터를 V3로 성공적으로 변환했습니다",
    convertErrorMessage: "HypaV2 데이터를 V3로 변환하는데 실패했습니다: {0}",
    noSummariesLabel: "아직 요약이 없습니다",
    searchPlaceholder: "#N, ID 또는 검색어 입력",
    summaryNumberLabel: "요약 #{0}",
    deleteThisConfirmMessage: "이 요약을 삭제하시겠습니까?",
    deleteAfterConfirmMessage: "이 요약 이후의 모든 요약을 삭제하시겠습니까?",
    deleteAfterConfirmSecondMessage:
      "이 작업은 되돌릴 수 없습니다. 정말 삭제하시겠습니까?",
    translationLabel: "번역",
    rerolledSummaryLabel: "재생성된 요약",
    rerolledTranslationLabel: "재생성된 요약 번역",
    connectedMessageCountLabel: "연결된 메시지 ({0})",
    connectedFirstMessageLabel: "첫 메시지",
    connectedMessageRoleLabel: "{0}의 메시지",
    connectedMessageNotFoundLabel: "메시지를 찾을 수 없습니다",
    connectedMessageLoadingError:
      "연결된 메시지를 불러오는 동안 오류 발생: {0}",
    connectedMessageTranslationLabel: "번역",
    nextSummarizationFirstMessageLabel: "첫 메시지",
    nextSummarizationNoMessageIdLabel: "메시지 ID 없음",
    nextSummarizationLabel: "HypaV3가 [{0}]를 요약할 예정입니다",
    nextSummarizationNoMessagesFoundLabel: "경고: 메시지를 찾을 수 없습니다",
    nextSummarizationLoadingError:
      "다음 요약 대상을 불러오는 동안 오류 발생: {0}",
    summarizationConditionLabel:
      "팁: HypaV3는 입력 토큰이 최대 컨텍스트 크기를 넘으면 요약을 시작합니다.",
    emptySelectedFirstMessageLabel: "경고: 선택된 첫 메시지가 비어있습니다",
    unclassified: "미분류",
    reSummarize: "재요약",
    reSummarizing: "재요약 중...",
    reSummarizeResult: "재요약 결과",
    retry: "재시도",
    translate: "번역",
    tag: "태그",
    tagManager: "태그 관리",
    tagManagerTitle: "태그 관리 - 요약본 #{0}",
    newTagName: "새 태그 이름",
    noTagsYet: "아직 태그가 없습니다.",
    addNewTagHint: "위에서 새 태그를 추가해보세요.",
    categoryManager: "카테고리",
    allCategories: "전체",
    categoryName: "카테고리 이름",
    noCategoriesYet: "아직 카테고리가 없습니다.",
    addNewCategoryHint: "위의 + 버튼을 클릭해서 추가해보세요.",
  },
  bulkEnabling: "한번에 로어북 활성화 버튼",
  showTranslationLoading: "번역 로딩 보이기",
  showDeprecatedTriggerV1: "비권장 트리거 V1 보이기",
  showDeprecatedTriggerV2: "비권장 트리거 V2 보이기",
  triggerV1Warning: "트리거 V1은 비권장입니다. 추후에 제거될 수 있습니다.",
  copy: "복사",
  paste: "붙여넣기",
  depth: "깊이",
  returnCSSError: "CSS 오류 반환",
  alwaysActiveInChat: "언제나 활성화 (현재 챗)",
  childLoreDesc:
    "이것은 캐릭터 로어의 복사본이며, 삭제하거나 원본 로어에서 직접 비활성화하기 전에는 '언제나 활성화' 상태로 유지됩니다.",
  thinkingTokens: "사고 토큰",
  thinkingType: "사고 모드",
  adaptiveThinkingEffort: "적응형 사고 수준",
  antiServerOverload: "서버 과부하 방지",
  localActivationInGlobalLorebook: "글로벌 로어북에서 로컬 활성화",
  cachePoint: "캐시 포인트",
  all: "모두",
  showFolderNameInIcon: "아이콘에 폴더 이름 표시",
  claudeCachingRetrival: "Claude 캐싱 재활용",
  claudeCachingRetrivalDesc:
    "4분마다 요청하여 Claude 캐싱의 캐시 시간을 연장합니다. 캐시 누락률을 줄일 수 있지만, 적절히 사용하지 않으면 비용이 증가할 수 있습니다.",
  automaticCachePoint: "자동 캐시 포인트",
  experimentalChatCompression: "실험적 채팅 데이터 처리",
  loadingChatData: "채팅 데이터 로딩 중",
  selectChatToView: "채팅을 선택해주세요",
  outputImageModal: "출력 이미지 모달",
  playMessageOnTranslateEnd: "번역 완료 시 오디오 재생",
  soundAndNotification: "소리 및 알림",
  groupBrowserNotification: "브라우저 알림",
  groupMessageNotification: "메세지 완료 알림",
  groupTranslateNotification: "번역 완료 알림",
  notificationEnable: "알림 사용",
  soundEffect: "효과음",
  soundEffectVolume: "효과음 볼륨",
  selectNotificationSound: "알림 소리 선택",
  uploadSound: "직접 업로드",
  uploadedSound: "업로드한 소리",
  soundDefault: "기본음",
  descBrowserNotification: "응답이 완료되면 브라우저 알림을 표시합니다.",
  descMessageSound: "응답이 완료되면 효과음을 재생합니다.",
  descTranslateSound: "번역이 완료되면 효과음을 재생합니다.",
  auxModelUnderModelSettings: "보조 모델 분리를 모델 설정에 표시",
  showModelInSidebar: "사이드바에 모델 선택 표시",
  showPresetInSidebar: "사이드바에 프리셋 선택 표시",
  showPersonaInSidebar: "사이드바에 페르소나 바인딩 표시",
  disableMobileDragDrop: "모바일에서 캐릭터 드래그 앤 드롭 비활성화",
  disableToggleBinding: "채팅 토글 바인딩 비활성화",
  seperateModelsForAxModels: "보조 모델 분리",
  axModelsDef: "보조 모델 정의",
  doNotChangeSeperateModels: "프리셋 변경 시 분리된 모델 변경하지 않기",
  useDefaultSubModel: "기본 보조모델 사용",
  modelPresetBindingMainUnset:
    "이 채팅에 바인딩된 메인 모델 프리셋이 없습니다. 전송하려면 바인딩하세요.",
  modelPresetBindingSubUnset:
    "이 채팅에 바인딩된 보조 모델 프리셋이 없습니다. 전송하려면 바인딩하세요.",
  modelPresetBindingTitle: "모델/보조 모델 프리셋 바인딩",
  modelBindingTitle: "모델 바인딩",
  modelSlotLegacySection: "레거시 모델",
  modelSlotLegacyGlobal: "레거시 · 전역 설정 따름",
  modelSlotLegacyGlobalShort: "전역 설정 따름",
  modelSlotPresetSection: "모델 프리셋",
  modelSlotLegacyBadge: "레거시",
  modelSlotLegacyGlobalHint: "전역 레거시 모델 (프롬프트 프리셋을 바꾸면 같이 바뀜):",
  useModelPresetBindingToggle: "모델 프리셋 바인딩 사용하기",
  modelPresetConfigure: "모델 프리셋 설정하기",
  modelPresetSetDefaultConfirm:
    "현재 모델 바인딩을 새 채팅 기본값으로 지정할까요?",
  modelPresetBindedSuccess: "모델 프리셋이 성공적으로 바인드되었습니다.",
  maxContextCapInfo: "모델 프로필 한도: {} 토큰. 비워 두거나 이 값을 넘게 입력하면 이 한도까지만 사용합니다.",
  maxContextCapExceeded: "입력값이 모델 프로필 한도를 넘어 {} 토큰까지만 사용됩니다. 그대로 쓰려면 아래 \"모델 한도 무시\"를 켜세요.",
  maxContextIgnoreCap: "모델 한도 무시",
  maxContextIgnoreCapHelp: "프로필에 적힌 컨텍스트 한도가 실제와 다를 때 켭니다. 위에 입력한 값을 그대로 쓰며, 실제 한도를 넘기면 서비스 쪽에서 에러가 납니다. 값을 비워 두면 효과가 없습니다.",
  streamingOverride: "응답 스트리밍",
  streamingOverrideHelp: "이 프리셋이 응답을 스트리밍할지 여부.",
  decoupledStreaming: "디커플드 스트리밍 (한 번에 출력)",
  decoupledStreamingHelp: "요청은 스트리밍으로 보내되 응답은 완성된 뒤 한 번에 표시합니다. 일부 프로바이더의 비스트리밍 출력 제한·타임아웃을 우회하고, 토큰 단위 렌더 부담을 줄입니다.",
  modelPresetToolUse: "도구 사용",
  modelPresetToolUseHelp: "이 프리셋이 설정된 도구(MCP)를 호출하도록 허용합니다. 기본 꺼짐. 도구 실행 시 스트리밍 없이 전송됩니다.",
  modelPresetAbilities: "모델 능력",
  modelPresetPickSuggestion: "추천에서 선택…",
  modelPresetSnapshotEmpty: "이 프리셋의 프로필 데이터가 비어 있습니다. 프로필을 다시 받거나 교체해 설정을 복구하세요.",
  modelPresetImageInput: "이미지 입력",
  modelPresetImageInputHelp: "이미지를 모델에 함께 전송합니다. 기본 꺼짐. 이미지를 지원하는 모델(예: Ollama gemma3, llava)에서만 켜세요.",
  modelPresetFoldSystem: "시스템 프롬프트 접기",
  modelPresetFoldSystemHelp: "system 메시지를 user 턴으로 변환해 보냅니다. 기본 꺼짐. 네이티브 system 역할을 지원하지 않는 모델(예: Ollama gemma3)에서 켜세요.",
  modelPresetKeepFirstSystem: "첫 시스템 프롬프트 유지",
  modelPresetKeepFirstSystemHelp: "접기를 켤 때, 맨 앞 system 메시지는 변환하지 않고 그대로 둡니다. 선두 system 하나만 허용하는 모델용.",
  modelPresetAlternateRole: "역할 교차 강제",
  modelPresetAlternateRoleHelp: "연속된 같은 역할의 메시지를 하나로 합칩니다. 기본 꺼짐. user/assistant 교차를 요구하는 모델(예: gemma)에서 켜세요.",
  modelPresetStartWithUser: "user 입력으로 시작",
  modelPresetStartWithUserHelp: "대화가 user로 시작하지 않으면 빈 user 턴을 앞에 추가합니다. 기본 꺼짐. 첫 턴이 user가 아니면 거부하는 모델용.",
  modelPresetCacheSection: "컨텍스트 캐싱",
  modelPresetCacheEnable: "컨텍스트 캐싱 사용",
  modelPresetCacheEnableHelp: "반복되는 프롬프트 앞부분을 Google 서버에 캐시해 입력 토큰 비용을 줄입니다. 캐시 경계는 프롬프트 템플릿의 cache 카드(또는 자동 캐시 포인트)가 정합니다.",
  modelPresetCachePluginWarning: "외부 캐시 관련 플러그인과 함께 사용하면 서로 충돌하여 캐싱이 정상 동작하지 않습니다. 둘 중 하나만 사용하세요.",
  modelPresetCacheTtl: "캐시 유지 시간 (초)",
  modelPresetCacheTtlHelp: "서버가 캐시를 보관하는 시간. 길수록 턴 사이 공백을 잘 견디지만, 유지 시간만큼 보관 비용이 발생합니다.",
  modelPresetCacheExtend: "적중 시 유지 시간 연장",
  modelPresetCacheExtendHelp: "요청이 캐시에 적중하면 유지 시간을 다시 연장합니다.",
  modelPresetCacheAdvanced: "고급",
  modelPresetCacheMinTokens: "최소 프롬프트 토큰",
  modelPresetCacheMinTokensHelp: "프롬프트가 이 토큰 수보다 작으면 캐시를 만들지 않습니다.",
  modelPresetCacheGrowth: "재생성 증가량 (토큰)",
  modelPresetCacheGrowthHelp: "캐시 생성 후 프롬프트가 이만큼 자라면 캐시를 다시 만듭니다.",
  maxContextHelp: "이 프리셋의 입력(프롬프트) 토큰 예산. 비우면 기본값(65000)을 쓰고, 모델 컨텍스트 윈도우 한도로 제한됩니다. 응답 길이(Max Tokens)와는 다릅니다.",
  modelPresetTabPresets: "프리셋",
  modelPresetTabOptions: "설정",
  modelPresetTabTest: "테스트",
  modelPresetTabModules: "모듈 분리 바인딩",
  moduleModelBindingEnable: "모듈별 모델 지정 사용",
  moduleModelBindingUnset: "지정 안 함",
  moduleModelBindingEmpty: "모델을 호출하는 모듈이 없습니다.",
  moduleModelBindingDangling: "지정된 프리셋을 찾을 수 없습니다. 다시 선택하거나, 프리셋을 다시 불러오면 연결됩니다.",
  modelPresetTestTitle: "테스트 요청",
  modelPresetTestHelp: "이 프리셋으로 메시지 하나를 보내 자격증명과 엔드포인트가 응답하는지 확인합니다. 채팅에는 저장되지 않습니다.",
  modelPresetTestSend: "테스트 전송",
  modelPresetTestSending: "전송 중…",
  modelPresetTestSuccess: "성공",
  modelPresetTestFail: "실패",
  modelPresetTestDefault: "세차를 하려고 해. 세차장은 50미터 떨어져 있어. 걸어가야 할까, 운전해서 가야 할까?",
  profileVisibilityLevel: "프로필 표시 수준",
  profileVisibilityAll: "전체 표시",
  profileVisibilityHideDeprecated: "지원 종료 숨기기",
  profileVisibilityCurrentOnly: "최신만 표시",
  useCustomRegistry: "커스텀 레지스트리",
  customRegistryUrl: "레지스트리 URL",
  customRegistryWarning: "신뢰할 수 있는 레지스트리 출처만 사용하세요. 악의적인 레지스트리는 요청과 API 키를 의도하지 않은 서버로 보낼 수 있습니다.",
  registryRefresh: "레지스트리 동기화",
  registryRefreshHelp: "현재 레지스트리 출처에서 카탈로그를 다시 받습니다.",
  registryRefreshNow: "지금 새로고침",
  registrySyncing: "동기화 중…",
  registrySyncUpdated: "최신 카탈로그로 갱신했습니다.",
  registrySyncUpToDate: "이미 최신입니다.",
  registryRefreshed: "새로고침했습니다.",
  registrySyncFailed: "동기화 실패",
  modelPresetDeleted: "삭제된 프리셋",
  modelPresetUnset: "미설정",
  modelPresetSetAsDefault: "현재 바인딩을 새 채팅 기본값으로",
  modelPresetDefaultSaved: "기본 바인딩으로 저장됨",
  modelPresetSaveAsDefaultButton: "기본값으로 저장",
  modelModeLabel: "모델 모드",
  modelModeLegacy: "레거시 모델",
  modelModePreset: "모델 프리셋",
  modelModeSettingsTitle: "모델 모드 설정으로 이동",
  modelModeLockLabel: "모델 모드 설정",
  modelModeLockLegacy: "레거시 모델 모드 고정",
  modelModeLockLegacyDesc: "기존 RisuAI의 모델 시스템을 사용합니다",
  modelModeLockPreset: "모델 프리셋 모드 고정",
  modelModeLockPresetDesc: "포켓리스의 모델 프리셋 바인딩 시스템을 사용합니다",
  modelModeLockNone: "고정 없음",
  modelModeLockNoneDesc: "채팅별로 설정을 지정합니다",
  newChatModelModeLabel: "신규 채팅 기본 모델 모드",
  modelTabBuiltin: "기본 모델",
  modelTabPlugin: "플러그인",
  axModelMemory: "장기 기억",
  axModelTranslate: "번역",
  axModelEmotion: "감정",
  axModelOther: "기타",
  tools: "도구",
  action: "동작",
  hotkey: "단축키",
  hotkeyDesc: {
    reroll: "재생성",
    unreroll: "재생성 취소",
    translate: "번역",
    remove: "제거",
    edit: "편집",
    copy: "복사",
    send: "전송",
    settings: "설정",
    home: "홈",
    presets: "빠른 프리셋 선택",
    persona: "빠른 페르소나 선택",
    modelSelect: "빠른 모델 선택",
    toggleCSS: "CSS 토글",
    prevChar: "이전 캐릭터",
    nextChar: "다음 캐릭터",
    quickMenu: "빠른 메뉴",
    quickSettings: "빠른 설정",
    toggleVoice: "음성 토글",
    toggleLog: "로그 토글",
    previewRequest: "요청 미리보기",
    import: "가져오기",
    export: "내보내기",
    webcam: "웹캠 토글",
    focusInput: "입력창 포커스",
    scrollToActiveChar: "활성 캐릭터로 스크롤",
  },
  screenTooSmall: "화면이 너무 작아서 인터페이스를 표시할 수 없습니다.",
  advancedModelSettings: "고급 모델 설정",
  fallbackModel: "대체 모델",
  fallbackWhenBlankResponse: "빈 응답 시 대체",
  doNotChangeFallbackModels: "프리셋 변경 시 대체 모델 변경 안 함",
  customModels: "커스텀 모델",
  igpPrompt: "IGP 프롬프트",
  useTokenizerCaching: "토크나이저 캐싱",
  hypaMemoryV3Modal: "하이파 V3 모달",
  showMenuHypaMemoryModal: "메뉴에서 하이파 모달 보이기",
  promptInfoInsideChat: "채팅에 프롬프트 정보 추가하기",
  promptTextInfoInsideChat: "채팅에 프롬프트 텍스트 정보 추가하기",
  promptInfoEmptyMessage: "이 메시지에 대한 프롬프트 정보가 없습니다.",
  promptInfoEmptyToggle: "활성화된 커스텀 토글이 없습니다.",
  promptInfoEmptyText: "저장된 프롬프트 텍스트가 없습니다.",
  escapeOutput: "출력 이스케이프",
  claudeBatching: "Claude 배칭",
  claude1HourCaching: "Claude 1시간 캐싱",
  folderNameInput: "새 폴더 이름을 입력해주세요",
  folderRemoveLengthError: "폴더를 제거하려면 폴더가 비어 있어야 합니다.",
  personaNotePlaceholder: "이 페르소나를 구분할 고유 식별자를 입력하세요. 예: \"헌터 페르소나\"",
  personaDuplicate: "복제",
  mcpAccessPrompt:
    '{{tool}}이(가) "{{action}}"을(를) 시도하고 있습니다. 허용하시겠습니까?',
  rememberToolUsage: "도구 사용 기억하기",
  simplifiedToolUse: "단순화된 도구 사용",
  toolCalled: "도구 '{{tool}}' 호출됨",
  static: "정적",
  dynamic: "동적",
  assetStyle: "에셋 스타일",
  insertAssetPrompt: "에셋 프롬프트 삽입",
  requestLocation: "리퀘스트 위치",
  newImageHandlingBeta: "새로운 이미지 처리 (베타)",
  settingsExported:
    "버그 리포트용 설정이 내보내지고 클립보드에 복사되었습니다.",
  bookmarks: "북마크",
  noBookmarks: "북마크 없음",
  bookmarkAskNameOrDefault:
    "북마크 이름을 입력하세요. 입력하지 않으면 자동으로 할당됩니다.",
  bookmarkAskNameOrCancel:
    "북마크 이름을 입력하세요. 입력하지 않으면 이름 변경이 취소됩니다.",
  collapseAll: "모두 접기",
  expandAll: "모두 펼치기",
  hideErrorDetails: "오류 세부사항 숨기기",
  showErrorDetails: "오류 세부사항 보이기",
  dynamicOutput: "동적 출력",
  autoAdjustSchema: "스키마 자동 조정",
  dynamicMessages: "동적 메시지",
  dynamicMemory: "동적 메모리",
  dynamicResponseTiming: "동적 응답 타이밍",
  showTypingEffect: "타이핑 효과 표시",
  dynamicRequest: "동적 요청",
  dynamicOutputPrompt: "동적 출력 프롬프트",
  settingsCloseButtonSize: "설정 닫기 버튼 크기",
  translating: "번역 중...",
  stackTraceTranslationFailed:
    "스택 트레이스 번역에 실패했습니다. 아래에 원래 난독화된 스택 트레이스를 표시합니다.",
  translate: "코드 주소 번역하기",
  apply: "적용",
  send: "전송",
  add: "추가",
  nightlyWarning:
    "## 나이틀리 빌드\n\n나이틀리 빌드에 연결하려고 합니다. 이 버전은 테스트용이며 버그가 포함되어 있을 수 있습니다. **이 버전에서는 버그 등 문제가 발생하더라도 직접적으로 해결하는 것을 지원하지 않습니다.**",
  loginSionyw: "Sionyw 계정으로 로그인",
  pluginRiskDetectedAlert:
    "PocketRisu가 API 키나 개인 데이터를 훔칠 수도 있는 위험한 코드를 감지했습니다. 이 플러그인을 설치하지 않는 것을 권장합니다.",
  doNotInstall: "설치하지 않음",
  continueAnyway: "무시하고 계속",
  pluginNoRiskButAlert:
    "PocketRisu가 위험한 코드를 감지하지 못했지만, 신뢰할 수 없는 출처의 플러그인을 설치하면 보안 위험이 발생할 수 있습니다.",
  pluginRisksInuserFriendly: {
    eval: "문자열에서 코드 실행",
    globalAccess: "글로벌 변수 접근",
    thisOutsideClass: "클래스 컨텍스트 외부에서 'this' 사용",
    errorInVerification: "검증 과정 중 오류 발생",
    storageAccess: "스토리지 접근",
  },
  pluginRisksInuserFriendlyDesc: {
    eval: "플러그인이 문자열에서 코드를 실행하려고 합니다. 악성 코드를 숨기기 위해 문자열이 난독화되었을 수 있습니다.",
    globalAccess:
      "플러그인이 글로벌 변수에 접근하려고 합니다. 이는 의도치 않은 부작용이나 보안 취약점으로 이어질 수 있습니다.",
    thisOutsideClass:
      "플러그인이 클래스 컨텍스트 외부에서 'this' 키워드를 사용하고 있습니다. 이는 의도치 않은 동작이나 보안 문제로 이어질 수 있습니다.",
    errorInVerification:
      "플러그인의 검증 과정 중 오류가 발생했습니다. 이는 기능상의 잠재적인 문제를 나타냅니다.",
    storageAccess:
      "플러그인이 스토리지에 접근하려고 합니다. 이는 데이터 유출이나 무단 데이터 조작으로 이어질 수 있습니다.",
  },
  generatedByAIDisclaimer:
    "이 콘텐츠는 AI에 의해 생성되었으며 부정확하거나 편향된 정보가 포함될 수 있습니다.",
  aiGenerationWarning:
    "콘텐츠는 AI로 생성되며 부정확하거나 편향된 정보가 포함될 수 있습니다.",
  autoScrollToNewMessage: "새 메시지로 자동 스크롤",
  alwaysScrollToNewMessage: "항상 새 메시지로 스크롤 (스크롤 위치 무시)",
  newMessage: "새 메시지",
  newMessageButtonStyle: "새 메시지 버튼 스타일",
  newMessageButtonBottomCenter: "하단 중앙 (기본값)",
  newMessageButtonBottomRight: "하단 우측",
  newMessageButtonBottomLeft: "하단 좌측",
  newMessageButtonFloatingCircle: "아이콘 원 (우측 하단)",
  newMessageButtonRightCenter: "우측 중앙",
  newMessageButtonTopBar: "상단 바",
  longPressToPopupEditor: "길게 눌러 팝업 편집기 열기",
  showInputActionBar: "입력창 액션 바 표시",
  createFolderOnBranch: "분기 시 폴더 생성",
  goToChat: "채팅으로 이동",
  duplicatePluginFoundUpdateIt:
    "중복된 플러그인이 발견되었습니다. 기존 플러그인을 업데이트하시겠습니까?",
  loadMore: "더 보기",
  pluginUpdateFoundInstallIt:
    "플러그인 업데이트가 발견되었습니다. 업데이트를 설치하시겠습니까?",
  branchedText: "이 채팅은 {}에서 분기되었습니다.",
  disableMessage: "메시지 비활성화",
  disableFirstMessageConfirm: "퍼스널 메세지를 비활성화할까요? 컨텍스트에서 제외됩니다.",
  bookmark: "북마크",
  branch: "분기점",
  fetchLogConsent:
    "플러그인 {} 이(가) 로그를 가져오려고 합니다. 민감한 정보가 노출될 수 있습니다. 허용하시겠습니까?",
  getFullDatabaseConsent:
    "플러그인 {} 이(가) 전체 데이터베이스에 접근하려고 합니다. 민감한 정보가 노출될 수 있습니다. 허용하시겠습니까?",
  mainDomAccessConsent:
    "플러그인 {} 이(가) 메인 Document에 접근하려고 합니다. 민감한 정보가 노출될 수 있습니다. 허용하시겠습니까?",
  replacerPermissionConsent:
    "플러그인 {} 이(가) 채팅 내용을 교체할 권한을 요청합니다. 대화 조작에 사용될 수 있습니다. 허용하시겠습니까?",
  providerPermissionConsent:
    "플러그인 {} 이(가) Provider 접근 권한을 요청합니다. 무단 API 호출이 발생할 수 있습니다. 허용하시겠습니까?",
  inlayPermissionConsent:
    "플러그인 {}이(가) 인레이에 접근할 권한을 요청하고 있습니다. 인레이 내용을 읽거나 쓰거나 수정할 수 있습니다. 허용하시겠습니까?",
  sendChatConsent:
    "플러그인 {} 이(가) 사용자 대신 채팅 메시지를 전송할 권한을 요청합니다. AI 응답이 트리거됩니다. 허용하시겠습니까?",
  pluginPermissionDenyGuide:
    '플러그인 "{}"의 권한 요청을 거부했습니다. 거부한 권한은 다시 묻지 않습니다.\n\n실수로 거부했다면 [설정] > [플러그인]에서 해당 플러그인의 "권한 응답 초기화"로 되돌릴 수 있습니다.',
  pluginFullStorageAccess: "다른 플러그인 데이터 전체 제공 (원본 RisuAI 호환)",
  pluginFullStorageAccessDesc:
    "이 플러그인이 DB를 읽을 때 모든 플러그인의 저장 데이터를 함께 넘깁니다. 현재 플러그인 저장소 {} 전체가 읽을 때마다 복사되므로, 다른 플러그인 데이터가 필요한 플러그인에만 켜세요.",
  pluginFullStorageAccessLarge: "플러그인 저장소가 100 MB를 넘습니다. 자주 읽는 플러그인에 켜면 앱이 느려지거나 멈출 수 있습니다.",
  pluginFullStorageAccessGuide: "자세히 보기",
  resetPluginPermission: "권한 응답 초기화",
  resetPluginPermissionConfirm:
    '플러그인 "{}"의 저장된 권한 응답(허용/거부 이력)을 모두 삭제하시겠습니까?\n\n다음에 플러그인이 권한을 요청할 때 다시 묻게 됩니다.',
  resetPluginPermissionDone: '"{}"의 권한 응답을 초기화했습니다',
  pluginV2Warning:
    "플러그인 V2 및 V2.1은 안전하지 않다고 간주되며, 향후 버전에서는 동작이 중단됩니다. **이 버전의 플러그인을 사용하지 마세요.** 이 플러그인의 개발자라면 가능한 한 빨리 V3로 업데이트해주세요.",
  partialBackupFirstConfirm:
    "⚠️ 경고: 부분 로컬 백업 ⚠️\n\n이 백업은 최소한의 필수 정보만 빠르게 저장하는 기능입니다.\n\n포함되는 것:\n- 데이터베이스 (채팅 기록, 캐릭터, 모듈, 플러그인, 프롬프트, 설정 등)\n- 캐릭터 프로필 아이콘 (메인 이미지)\n- 사용자 아이콘 및 커스텀 배경\n- 페르소나 아이콘\n- 폴더 이미지\n- 봇 프리셋 이미지\n\n⚠️ 포함되지 않는 것:\n- 감정 이미지\n- 추가 캐릭터 에셋\n- VITS 음성 파일\n- 기타 모든 추가 미디어 파일\n\n이 백업 파일에는 모든 캐릭터 에셋이 포함되지 않습니다!\n완전한 백업이 필요하다면 일반 로컬 백업을 사용하세요.\n\n그래도 계속하시겠습니까?",
  partialBackupSecondConfirm:
    "⚠️⚠️ 최종 경고 ⚠️⚠️\n\n이 백업은 캐릭터의 프로필 이미지만 저장하며, 나머지 대부분의 에셋은 저장하지 않습니다!\n\n저장되는 것:\n- 데이터베이스 (채팅 기록, 캐릭터, 모듈, 플러그인, 프롬프트, 설정 등)\n- 캐릭터 프로필 아이콘 (메인 이미지)\n- 사용자 아이콘 및 커스텀 배경\n- 페르소나 아이콘\n- 폴더 이미지\n- 봇 프리셋 이미지\n\n저장되지 않는 것:\n- 감정 이미지\n- 추가 캐릭터 에셋\n- VITS 음성 파일\n- 기타 모든 미디어 파일\n\n⚠️ 백업 파일에 캐릭터 에셋이 필요하지 않은 경우에만 진행하세요! ⚠️\n\n정말로 부분 백업을 진행하시겠습니까?",
  savePartialLocalBackup: "부분 로컬 백업 저장 (캐릭터 에셋 제외)",
  serverBackupHeader: "포켓리스 서버 백업",
  serverBackupDesc:
    "다운로드 없이 포켓리스가 설치된 기기(서버)에 직접 백업 파일을 저장하고 복원합니다.",
  serverBackupSave: "서버에 백업 저장",
  serverBackupManage: "서버 백업 관리",
  serverBackupSaving: "서버에 백업 저장 중...",
  pluginStorageV2PreloadFailed: "플러그인 저장소를 불러오지 못해 V2 플러그인을 실행하지 않았습니다. 새로고침하면 다시 시도합니다.",
  serverBackupSaveSuccess: (filename: string, size: string, dir?: string) =>
    `백업 저장 완료: ${filename} (${size})${dir ? ` — 저장 위치: ${dir}` : ''}`,
  serverBackupLoading: "백업 목록 불러오는 중...",
  serverBackupEmpty: "서버에 저장된 백업이 없습니다.",
  serverBackupRestore: "복원",
  serverBackupDownload: "다운로드",
  serverBackupDelete: "삭제",
  serverBackupRestoring: "서버 백업에서 복원 중...",
  serverBackupDeleteConfirm: (filename: string) =>
    `"${filename}" 백업을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`,
  serverBackupDeleteSuccess: "백업이 삭제되었습니다.",
  bootstrap: {
    dataCorruptionDetected: (name: string, type: string) =>
      `데이터 손상 감지\n\n모듈 "${name}"의 로어북 형식이 손상되었습니다.\n\n손상된 데이터 타입: ${type}`,
    reportErrorQuestion:
      "다음 팝업 창에서 오류 정보를 복사한 후 개발자에게 보고하시겠습니까?\n같은 오류가 다시 발생하는 것을 막는 것에 큰 도움이 됩니다.\n(오류가 난 모듈 정보만 포함되며 다른 정보는 포함되지 않습니다)",
    diagnosticInformation: (reportData: string) =>
      `# 진단 정보\n\n아래 정보를 복사하여 GitHub Issues나 Discord, 커뮤니티를 통해 개발자에게 제보해주세요.\n제보 전에 민감한 정보가 있는지 다시 한번 확인해주세요:\n\n\`\`\`json\n${reportData}\n\`\`\``,
    resetLorebookQuestion:
      '이 손상된 모듈의 로어북 데이터만 초기화하시겠습니까?\n(다른 모듈이나 캐릭터 데이터는 영향받지 않습니다)\n"아니오"를 선택하면 데이터가 그대로 유지되지만 오류가 계속 발생할 수 있습니다.',
  },
  partialEdit: {
    editButtonTooltip: "수정",
    deleteButtonTooltip: "삭제",
    deleteModalTitle: "삭제 확인",
    deleteConfirmMessage: "이 부분을 삭제하시겠습니까?",
    deleteYes: "예",
    deleteNo: "아니오",
    editModalTitle: "부분 수정",
    matchFound: (method: string) => `매칭: ${method}`,
    matchFailedTitle: "부분 수정 불가",
    matchFailedMessage:
      "원본 메시지에서 정확한 위치를 찾을 수 없습니다. 매우 긴 문장이거나 중복된 내용인 경우 발생할 수 있습니다. 전체 메시지 수정 기능을 사용해주세요.",
    selectMatch: "수정할 블록을 선택하세요",
    selectDeleteMatch: "삭제할 블록을 선택하세요",
    matchesFound: "개의 매칭을 찾음",
    lineNumber: (line: number) => `약 ${line}줄`,
    saveShortcut: "저장 (Ctrl+Enter)",
    cancelShortcut: "취소 (Esc)",
    save: "저장",
    cancel: "취소",
  },
  hamburgerButtonBottom: "메뉴 버튼을 사이드바 하단으로 이동",
  keepSessionAlive: "세션 유지",
  keepSessionAlivePip: "PIP 사용",
  keepSessionAliveSound: "소리 사용",
  hideLeftBarCollapseButton: "메뉴바 접기 버튼 숨기기",
  toggleBindingLabel: "토글 바인딩",
  togglePinToChat: "채팅에 토글 바인드",
  togglePinLabel: "토글 바인드",
  togglePinSaved: "토글이 바인드 되었습니다.",
  toggleSaveAsDefaultButton: "기본값으로 저장",
  toggleSetDefaultConfirm: "현재 토글 상태를 새 채팅의 기본값으로 저장할까요? 새로 만드는 채팅은 이 상태로 바인드된 채 시작합니다.",
  toggleDefaultSaved: "토글 기본값으로 저장됨",
  toggleDefaultSavedButton: "기본값 저장됨",
  toggleDefaultManage: "새 채팅의 토글 기본값이 저장되어 있습니다.",
  toggleDefaultOverwrite: "현재 상태로 덮어쓰기",
  toggleDefaultClear: "기본값 해제",
  toggleDefaultCleared: "토글 기본값이 해제되었습니다. 새 채팅은 바인딩 없이 시작합니다.",
  toggleSaveAsPreset: "토글 프리셋으로 저장",
  toggleLoadPreset: "토글 프리셋에서 불러오기",
  togglePinUpdate: "토글 저장",
  togglePinUpdateLabel: "저장",
  togglePinRemove: "토글 바인드를 해제할까요?",
  togglePinUnbound: "토글 바인드가 해제되었습니다.",
  togglePresetNamePrompt: "토글 프리셋 이름을 입력하세요",
  togglePresetDelete: "── 삭제 ──",
  togglePresetDeleteConfirm: (name: string) =>
    `"${name}" 토글 프리셋을 삭제할까요?`,
  togglePresetSelectTitle: "토글 프리셋 선택",
  togglePresetEmpty: "저장된 토글 프리셋이 없습니다.",
  togglePresetRename: "토글 프리셋 이름 변경",
  togglePresetApplied: (name: string) => `"${name}" 프리셋이 적용되었습니다.`,
  togglePresetFilterShowAll: "모든 프리셋 보기",
  togglePresetNoPromptPreset: "프리셋 미지정",
  togglePresetEmptyFiltered:
    "현재 프롬프트 프리셋에 해당하는 토글 프리셋이 없습니다.",
  togglePresetApplyConfirm:
    "현재 토글 설정이 덮어씌워집니다. 적용하시겠습니까?",
  togglePresetMismatchConfirm:
    "현재 프리셋과 다릅니다. 토글이 호환되지 않을 수 있습니다. 적용하시겠습니까?",
  togglePresetSaveNew: "새 프리셋 저장",
  togglePresetOverwrite: "덮어쓰기",
  togglePresetOverwriteConfirm: (name: string) =>
    `"${name}"을(를) 현재 토글 값으로 덮어쓸까요?`,
  togglePresetOverwritten: (name: string) => `"${name}" 프리셋을 덮어썼습니다.`,
  togglePresetList: "토글 프리셋",
  togglePresetMenuRename: "이름 변경",
  togglePresetMenuDuplicate: "복제",
  togglePresetMenuDelete: "삭제",
  togglePresetMenuOverwrite: "덮어쓰기",
  togglePresetMenuExport: "내보내기",
  togglePresetImport: "파일에서 불러오기",
  togglePresetImported: (name: string) => `"${name}" 프리셋을 불러왔습니다.`,
  togglePresetImportError: "올바른 토글 프리셋 파일이 아닙니다.",
  togglePresetSaved: (name: string) => `"${name}" 프리셋을 저장했습니다.`,
  togglePresetRenamed: (oldName: string, newName: string) =>
    `"${oldName}" → "${newName}"으로 변경되었습니다.`,
  togglePresetDuplicated: (name: string) => `"${name}"으로 복제되었습니다.`,
  togglePresetDeleted: (name: string) => `"${name}" 프리셋을 삭제했습니다.`,
  togglePresetExported: (name: string) => `"${name}" 프리셋을 내보냈습니다.`,
  importSaveFolderHeader: "포켓리스로 세이브 불러오기",
  importSaveZip: "Save 폴더에서 불러오기 (Zip 업로드)",
  importSaveZipDesc:
    "사용하던 RisuAI 프로젝트의 save 폴더를 zip으로 압축한 뒤 여기에 업로드하면 데이터를 불러올 수 있습니다. 압축 파일 용량이 큰 경우 업로드에 실패할 수 있으며, 이 경우엔 서버의 save 폴더에 직접 복사한 후 재시작하면 자동으로 마이그레이션됩니다.",
  importSaveFolderScanning: "Save 폴더 스캔 중...",
  importSaveFolderImporting: "Save 폴더 불러오는 중...",
  importSaveFolderConfirmZip: (name: string, size: string) =>
    `"${name}" (${size})을 업로드하고 불러올까요? 현재 데이터를 대체합니다.`,
  importSaveFolderNoDatabase:
    "Save 폴더에 데이터베이스 파일(database/database.bin)이 없습니다. 불러오기를 진행할 수 없습니다.",
  importSaveFolderSuccess: "불러오기 완료.",
  cleanupMigratedFiles: "마이그레이션된 Save 파일 정리",
  cleanupMigratedDesc:
    "save 폴더를 직접 덮어씌워 마이그레이션한 경우, 이미 데이터베이스에 저장된 원본 파일을 삭제하여 디스크 공간을 확보합니다.",
  cleanupMigratedConfirm: (count: number, size: string) =>
    `마이그레이션 완료된 파일 ${count}개 (${size})를 삭제할까요? 이미 데이터베이스에 저장되어 있습니다.`,
  cleanupMigratedNoFiles: "정리할 파일이 없습니다.",
  cleanupMigratedNotReady: "마이그레이션이 아직 완료되지 않았습니다.",
  cleanupMigratedSuccess: (count: number, size: string) =>
    `${count}개 파일 삭제, ${size} 확보.`,
  cleanupMigratedCleaning: "마이그레이션된 파일 정리 중...",
  nanoGPTLoadingAccountInfo: "계정 정보 불러오는 중…",
  nanoGPTCreditBalance: "크레딧 잔액:",
  nanoGPTSubscription: "구독",
  nanoGPTGraceUntil: (date: string) => `${date}까지`,
  nanoGPTNoActiveSubscription: "활성 구독이 없습니다.",
  nanoGPTCancelsAtPeriodEnd: (date: string) => `기간 종료 시 해지 (${date})`,
  nanoGPTWeeklyTokens: (pct: string) => `주간 포함 입력 토큰 — ${pct} 사용됨`,
  nanoGPTDailyTokens: (pct: string) => `일간 포함 입력 토큰 — ${pct} 사용됨`,
  nanoGPTDailyImages: (pct: string) => `일간 포함 이미지 — ${pct} 사용됨`,
  nanoGPTResets: (date: string) => `${date}에 초기화`,
  nanoGPTUsed: (n: string) => `${n} 사용됨`,
  nanoGPTRemaining: (n: string) => `${n} 남음`,
  nanoGPTRenews: (date: string) => `갱신일: ${date}`,
  nanoGPTCouldNotLoadAccountInfo: "계정 정보를 불러올 수 없습니다.",
  nanoGPTWeeklyTokensLabel: "주간 포함 입력 토큰",
  nanoGPTDailyTokensLabel: "일간 포함 입력 토큰",
  nanoGPTDailyImagesLabel: "일간 포함 이미지",
  nanoGPTUsedLabel: "사용됨",
  nanoGPTRemainingLabel: "남음",
  nanoGPTResetsLabel: "초기화",
  nanoGPTRenewsLabel: "갱신일:",
  nanoGPTProvider: "제공자",
  nanoGPTProviderPayAsYouGoOnly: "(종량제 모드에서만 사용 가능)",
  nanoGPTProviderAuto: "자동",
  nanoGPTProviderFree: "무료",
  nanoGPTProviderInput: "입력",
  nanoGPTProviderOutput: "출력",
  nanoGPTProviderQuantization: "양자화",
  nanoGPTProviderUndisclosed: "미공개",
  nanoGPTProviderCache: "캐시",
  nanoGPTProviderCacheSupported: "지원",
  nanoGPTProviderCacheNotSupported: "미지원",
  nanoGPTProviderCacheRead: "캐시 읽기",
  nanoGPTUseSubscriptionEndpoint: "구독 엔드포인트 및 모델 사용",
  modelGridCouldNotLoad:
    "모델 목록을 불러올 수 없습니다. API 키를 확인해 주세요.",
  modelGridNoModelsMatch: (q: string) => `"${q}"에 맞는 모델이 없습니다`,
  modelGridContext: (n: string) => `컨텍스트: ${n}`,

  nanoGPTSelectFromList: "목록에서 선택",
  nanoGPTManualInput: "수동 입력",
  nanoGPTManualModelSelect: "수동 모델 선택",
  confirmInstallPluginViaPlugin:
    "다른 플러그인이 \"{plugin}\" 플러그인을 설치하려고 합니다. 요청한 플러그인을 신뢰할 수 없다면 위험할 수 있습니다. 계속하시겠습니까?",
  confirmReplacePluginViaPlugin:
    "다른 플러그인이 설치된 \"{plugin}\" 플러그인을 다른 스크립트로 바꾸려고 합니다. 요청한 플러그인을 신뢰할 수 없다면 위험할 수 있습니다. 계속하시겠습니까?",
  nodeOnlyRestoreLastChat: "시작 시 마지막 채팅 열기",
  nodeOnlyScrollButtonType: "스크롤 버튼 타입",
  scrollButtonTypeFour: "4버튼",
  scrollButtonTypeTwo: "2버튼",
  scrollButtonTypeOff: "사용 안 함",
  nodeOnlyServerSideRequests: "서버 사이드 요청",
  pendingSendNotice: "완료되지 못한 전송: {chars} — 해당 채팅을 열면 이어서 보냅니다.",
  searchSettingsPlaceholder: "설정 검색...",
  searchSettingsNoResults: "일치하는 설정이 없습니다",
  searchSettingsHint: "설정 이름이나 키워드로 검색하세요",
  // 원격 접속 (Cloudflare Quick Tunnel)
  remoteAccess: "원격 접속",
  remoteAccessDesc:
    "원격 접속 링크를 사용하여 다른 기기에서 이 포켓리스 서버에 접속할 수 있습니다.",
  remoteAccessOpen: "원격 접속 열기",
  remoteAccessClose: "원격 접속 닫기",
  remoteAccessCloseConfirm: "원격 접속을 닫을까요? 링크가 만료됩니다.",
  remoteAccessDownloading: "cloudflared 다운로드 중...",
  remoteAccessStarting: "터널 시작 중...",
  remoteAccessCopyUrl: "URL 복사",
  remoteAccessCopied: "복사됨!",
  remoteAccessDisabled: "서버 설정에 의해 원격 접속이 비활성화되어 있습니다.",
  remoteAccessError: "터널 오류",
  remoteAccessRetry: "재시도",
  remoteAccessQrHint: "QR 코드를 스캔하여 접속하세요",
  remoteAccessWarning:
    "QR 코드와 원격 링크를 절대로 다른 사람과 공유하지 마세요. 링크를 가진 누구나 서버에 자유롭게 접근할 수 있습니다. 실수로 공유한 경우, 원격 접속을 닫고 새 링크를 생성하세요.",
  remoteAccessInfo:
    "원격 접속을 닫거나 서버를 종료/재시작하면 링크가 만료되며, 다시 연결하면 새로운 링크가 생성됩니다. 이 페이지나 브라우저를 닫아도 원격 접속은 유지됩니다.",
  remoteAccessTermuxWarning:
    "Termux 환경에서는 Cloudflare Quick Tunnel을 사용할 수 없습니다. Tailscale 등 다른 원격 접속 도구를 사용해 주세요.",

  // 비보안(HTTP) 접속 안내
  httpInsecureWarningTitle: "HTTP로 접속 중",
  httpInsecureWarningBody:
    "플러그인 등 일부 기능이 동작하지 않을 수 있습니다. 원격 접속 기능을 사용하면 HTTPS로 연결할 수 있습니다.",
  httpInsecureOpenRemoteAccess: "설정 열기",
  transferSizeWarningTitle: "전송 데이터 용량이 권장 크기를 넘었습니다",
  transferSizeWarningBody:
    "현재 약 {{size}}로, 원격 접속 시 저장이 실패할 수 있습니다. 사용하지 않는 캐릭터를 비활성화하면 전송 데이터 용량이 줄어듭니다.",
  transferSizeOpenCharacterManager: "캐릭터 관리",
  transferSizeDismiss: "이번 세션에서 숨기기",
  transferSizeWarningToggle: "권장 크기를 넘으면 메인 화면에 경고 표시",
  transferSizeWarningToggleDesc:
    "업로드 크기 제한이 없는 방식으로 접속한다면 꺼도 됩니다. Cloudflare를 거치면(Quick Tunnel, 프록시를 켠 자체 도메인 포함) 100 MB 제한이 있으니 켜 두세요.",

  // 시스템 페이지
  system: "시스템",
  systemLogs: "시스템 로그",
  systemLogsDesc:
    "서버 및 연결된 브라우저에서 발생한 에러, 경고, 정보 이벤트를 확인합니다.",
  systemLogsEmpty: "로그가 없습니다",
  systemLogsEmptyDesc: "에러나 경고가 발생하면 여기에 기록됩니다.",
  systemLogsEmptyButMore:
    "현재 로드된 범위에는 조건에 맞는 로그가 없습니다. 더 보기로 과거 로그를 탐색하세요.",
  systemLogsSearchPlaceholder: "메시지, 소스, 플랫폼, 기기 ID로 검색",
  systemLogsLoadMore: "더 불러오기",
  systemLogsRefresh: "새로고침",
  systemLogsCopyAll: "보이는 항목 복사",
  systemLogsCopyEntry: "복사",
  systemLogsClearAll: "전체 삭제",
  systemLogsClearConfirm: "모든 로그를 삭제할까요? 되돌릴 수 없습니다.",
  systemLogsCopied: "클립보드에 복사됨",
  systemLogsFiltered: (shown: number, total: number) =>
    `${total}개 중 ${shown}개 표시`,
  systemLogsLevelAll: "전체",
  systemLogsLevelError: "에러",
  systemLogsLevelWarning: "경고",
  systemLogsLevelInfo: "정보",
  systemLogsOriginAll: "전체",
  systemLogsOriginClient: "클라이언트",
  systemLogsOriginServer: "서버",
  systemLogsFailedLoad: "로그를 불러오지 못했습니다",
  systemLogsLoading: "불러오는 중...",
  pluginStorageTab: "플러그인 저장소",
  pluginStorageDesc: "플러그인이 저장한 데이터를 직접 보고 편집·삭제할 수 있습니다. 플러그인 데이터는 플러그인별로 분리되지 않고 하나의 전역 공간에서 공유됩니다.",
  pluginStorageBackendSave: "세이브 저장",
  pluginStorageBackendSaveDesc: "세이브 파일에 저장 · 세이브와 함께 이동",
  pluginStorageBackendLocal: "로컬",
  pluginStorageBackendLocalDesc: "localStorage 기반 · 문자열만 · 기기 로컬",
  pluginStorageBackendIdb: "서버 저장소",
  pluginStorageBackendIdbDesc: "서버에 저장 · JSON·바이너리 지원 · 세이브 백업에 미포함",
  pluginStorageSearchKey: "키 검색...",
  pluginStorageSearchValue: "값 검색...",
  pluginStorageRefresh: "새로고침",
  pluginStorageEmpty: "항목이 없습니다.",
  pluginStorageLoadError: "저장소를 불러올 수 없습니다.",
  pluginStorageNotLoaded: "열면 로드",
  pluginStorageSave: "저장",
  pluginStorageFormatJson: "JSON 정렬",
  pluginStorageMetaType: "타입",
  pluginStorageMetaSize: "크기",
  pluginStorageMetaBinarySize: "바이너리 데이터 크기",
  pluginStorageMetaMime: "MIME 타입",
  pluginStorageMetaFileName: "파일명",
  pluginStorageMetaChars: "문자 수",
  pluginStorageOwner: "출처(추정)",
  pluginStorageOwnerUnknown: "미상",
  pluginStorageDeleted: "삭제됨",
  pluginStorageJsonError: (msg: string) => `JSON 파싱 실패: ${msg}`,
  pluginStorageSaved: (key: string) => `"${key}" 저장됨`,
  pluginStorageDeleteConfirm: (key: string) => `"${key}" 항목을 삭제할까요?`,
  pluginStorageBulkDeleteShown: (n: number) => `보이는 ${n}개 삭제`,
  pluginStorageBulkDeleteAll: (n: number) => `전체 삭제 (${n})`,
  pluginStorageBulkDeleteConfirm: (backend: string, n: number) => `${backend} 백엔드의 ${n}개 항목을 삭제합니다. 되돌릴 수 없습니다.`,
  pluginStorageBulkDeleteAllConfirm: (backend: string, n: number) => `${backend} 백엔드의 모든 플러그인 데이터 ${n}개를 삭제합니다. 되돌릴 수 없습니다.`,
  pluginStorageBulkDeleted: (n: number) => `${n}개 항목을 삭제했습니다`,
  systemLogsFilters: "필터",
  systemLogsFilterLevel: "레벨",
  systemLogsFilterOrigin: "오리진",
  systemLogsFilterSource: "소스",
  systemLogsFilterDevice: "기기",
  systemLogsFilterClear: "필터 초기화",
  systemLogsFilterActive: (count: number) =>
    count === 0 ? "" : `${count}개 제외됨`,
  systemLogsExplicitOnly: "명시적 로그만",
  systemLogsExplicitOnlyHint: "console, 미처리 예외, 프레임워크 캡처 제외",

  // 리퀘스트 로그 / 사용량 (시스템 설정)
  requestLogsTab: "리퀘스트 로그",
  requestLogsDesc:
    "프로바이더로 나간 요청의 본문·응답·소요 시간을 기록합니다.",
  requestLogsFilters: "필터",
  requestLogsFilterClear: "필터 초기화",
  requestLogsFilterActive: (count: number) =>
    count === 0 ? "" : `${count}개 적용됨`,
  requestLogsFilterCategory: "종류",
  requestLogsFilterSource: "출처",
  requestLogsFilterResult: "결과",
  requestLogsCategoryLlm: "LLM",
  requestLogsCategoryTts: "음성",
  requestLogsCategoryImage: "이미지",
  requestLogsCategoryTranslate: "번역",
  requestLogsCategoryEmbedding: "임베딩",
  requestLogsCategoryOther: "기타",
  requestLogsSourceMain: "채팅",
  requestLogsSourceTranslate: "번역",
  requestLogsSourceMemory: "메모리",
  requestLogsSourceEmotion: "감정",
  requestLogsSourceSub: "보조",
  requestLogsSourcePreview: "미리보기",
  requestLogsSourceTest: "테스트",
  requestLogsSourceTts: "음성",
  requestLogsSourceImage: "이미지",
  requestLogsSourcePlugin: "플러그인",
  requestLogsSourceOther: "기타",
  requestLogsResultSuccess: "성공",
  requestLogsResultFailed: "실패",
  requestLogsRouteDirect: "직접",
  requestLogsRouteProxy: "프록시",
  requestLogsRouteJob: "백엔드 콜",
  requestLogsSearchPlaceholder: "URL, 모델, 오류 메시지로 검색",
  requestLogsRefresh: "새로고침",
  requestLogsClearAll: "전체 삭제",
  requestLogsClearConfirm:
    "저장된 리퀘스트 로그를 모두 삭제할까요? 사용량 통계는 유지됩니다.",
  requestLogsEmpty: "로그가 없습니다",
  requestLogsEmptyDesc: "요청을 보내면 여기에 기록됩니다.",
  requestLogsEmptyButMore: "현재 필터에 맞는 항목이 없습니다. 더 불러와 보세요.",
  requestLogsLoading: "불러오는 중...",
  requestLogsFailedLoad: "리퀘스트 로그를 불러오지 못했습니다",
  requestLogsLoadMore: "더 불러오기",
  requestLogsCount: (shown: number, total: number) =>
    shown === total ? `${total}건` : `${shown} / ${total}건`,
  requestLogsDuration: "소요 시간",
  requestLogsFirstToken: "첫 응답",
  requestLogsTokens: "토큰",
  requestLogsRequestHeaders: "요청 헤더",
  requestLogsRequestBody: "요청 본문",
  requestLogsResponse: "응답",
  requestLogsError: "오류",
  requestLogsCopied: "클립보드에 복사됨",
  requestLogsTruncated: "일부 생략됨",
  requestLogsEnabled: "리퀘스트 로그 기록",
  requestLogsEnabledDesc:
    "끄면 새 요청이 기록되지 않습니다. 사용량 통계도 함께 멈춥니다.",
  requestLogsStreamUsage: "스트리밍 요청 토큰 수집",
  requestLogsStreamUsageDesc:
    "스트리밍 응답의 토큰 사용량을 함께 받아옵니다. 프로바이더에 따라 400 오류가 발생할 수 있으며, 그런 경우 이 옵션을 끄세요.",
  requestLogsStorage: (used: string, max: string) =>
    `저장 용량 ${used} / ${max}`,

  usageTab: "사용량",
  usageDesc: "LLM 요청의 토큰 사용량 통계입니다. 음성·이미지 등 토큰이 없는 요청은 집계에서 제외됩니다.",
  usageRequests: "요청",
  usageInputTokens: "입력 토큰",
  usageOutputTokens: "출력 토큰",
  usageCachedTokens: "캐시 토큰",
  usageChartTitle: "토큰 사용 현황",
  usageByModel: "모델별",
  usageBySource: "출처별",
  usageModel: "모델",
  usageAvgDuration: "평균 응답",
  usageFailed: "실패",
  usagePeriod7d: "7일",
  usagePeriod30d: "30일",
  usagePeriod90d: "90일",
  usagePeriodAll: "전체",
  usageEmpty: "사용 기록이 없습니다",
  usageEmptyDesc: "요청을 보내면 통계가 쌓입니다.",
  usageLoading: "불러오는 중...",
  usageFailedLoad: "사용량을 불러오지 못했습니다",
  usageClearConfirm:
    "사용량 통계를 모두 삭제할까요? 되돌릴 수 없습니다.",
  usageClearAll: "통계 삭제",

  // 스토리지 대시보드
  systemDashboard: "대시보드",
  storageDashboardDesc:
    "스토리지 사용량을 확인하고, 큰 항목을 찾고, 공간을 회수합니다.",
  storageRefresh: "새로고침",
  storageLoading: "불러오는 중...",
  storageFailedLoad: "스토리지 통계를 불러오지 못했습니다",

  // 디스크 사용량 (맥OS 스타일 막대)
  storageDiskUsage: "저장공간",
  storageDiskHeader: (used: number, total: number) =>
    `${(total / 1024 / 1024 / 1024).toFixed(2)} GB 중 ${(used / 1024 / 1024 / 1024).toFixed(2)} GB 사용됨`,
  storageDiskHeaderUnknown: "디스크 크기를 가져오지 못했습니다",
  storageDiskOther: "기타 (시스템 및 다른 앱)",
  storageDiskFree: "여유 공간",
  storageDiskRisuTotal: (size: number) =>
    `PocketRisu 합계: ${(size / 1024 / 1024).toFixed(1)} MB`,

  // 항목별 라벨 (분포 리스트의 ⓘ 설명)
  storageRowDbFile: "risuai.db",
  storageRowDbFileDesc:
    "PocketRisu의 메인 SQLite 데이터베이스 파일. 모든 채팅·캐릭터·에셋·설정이 여기 들어갑니다.",
  storageRowWal: "WAL (Write-Ahead Log)",
  storageRowWalDesc:
    "임시 트랜잭션 로그. 저장이 먼저 여기 기록된 뒤 본 파일에 통합됩니다. 사용 중엔 정상적으로 존재.",
  storageRowShm: "SHM (공유 메모리)",
  storageRowShmDesc:
    "WAL용 SQLite 공유 메모리 인덱스. 작고 휘발성이며 필요 시 재생성됩니다.",
  storageRowFileBackups: "디스크 백업 (.bin)",
  storageRowFileBackupsDesc:
    "수동으로 export한 백업 파일. backups/ 폴더에 보관됩니다.",
  storageRowKvDatabase: "database.bin (활성)",
  storageRowKvDatabaseDesc:
    "risuai.db 내부에 있는 단일 BLOB 행. 캐릭터 메타·채팅·설정이 통째로 들어갑니다. 2 GB 단일 BLOB 한계의 적용 대상.",
  storageRowTransferSize: "전송 데이터 용량 (채팅 제외)",
  storageRowTransferSizeLimit: "권장 {{limit}} 이하",
  storageRowTransferSizeDesc:
    "저장할 때 서버로 보내는 데이터의 크기입니다 (이 기기에서 마지막 저장 기준). 권장 크기를 넘으면 원격 접속 시 저장이 실패할 수 있으니, 사용하지 않는 캐릭터를 비활성화해 전송 데이터 용량을 줄이세요.",
  storageRowKvDbBackups: "DB 백업 (인프로세스)",
  storageRowKvDbBackupsDesc:
    "risuai.db 내부에 자동으로 보관되는 database.bin 스냅샷. 약 500 MB 한도로 자동 로테이션.",
  storageRowKvAssets: "캐릭터 에셋",
  storageRowKvAssetsDesc:
    "캐릭터 카드, 이모션 이미지, 추가 에셋, 페르소나 아이콘 등.",
  storageRowKvInlay: "Inlay 이미지",
  storageRowKvInlayDesc: "메시지에 첨부된 이미지 (본체 + 썸네일 + 메타).",
  storageRowKvRemotes: "원격 채팅 데이터",
  storageRowKvRemotesDesc:
    "캐릭터별 원격 동기화 캐시 (remotes/{chaId}.local.bin).",
  storageRowKvColdStorage: "콜드 스토리지",
  storageRowKvColdStorageDesc: "레거시·휴면 저장 영역. 보통 비어 있습니다.",
  storageRowKvArchive: "비활성화 캐릭터",
  storageRowKvArchiveDesc:
    "비활성화한 캐릭터의 본문(채팅·에셋 목록 포함)과 색인. 활성화해도 자동으로 지워지지 않으며, 백업 내보내기에는 항상 완전한 캐릭터로 포함됩니다.",
  storageRowKvUncategorized: "기타 데이터",
  storageRowKvUncategorizedDesc:
    "위 분류에 들어가지 않는 키. 마이그레이션 잔여물이나 임시 항목 등이 여기 잡힙니다.",
  storageRowSqliteOverhead: "SQLite 오버헤드 (구조)",
  storageRowSqliteOverheadDesc:
    "인덱스, 페이지 헤더, 정렬 패딩 등 SQLite가 항상 들고 있는 구조적 영역입니다. 사용자 데이터가 아니며 정리로 제거되지 않습니다 (데이터 양에 비례해 자연 증가).",
  storageRowReclaimablePages: "SQLite 오버헤드 (회수 가능)",
  storageRowReclaimablePagesDesc:
    '삭제된 데이터가 남긴 빈 페이지로, SQLite 오버헤드 중 정리로 회수 가능한 부분입니다. 아래 "SQLite 오버헤드 정리"의 막대 노란색 부분과 같은 값이며, 정리 실행 시 모두 회수됩니다.',
  storageRowReclaimable: (size: number) =>
    `${(size / 1024 / 1024).toFixed(1)} MB 회수 가능 — Optimize로 압축.`,
  storageInternalOnly: "저장공간과 함께보기",
  storageInternalOnlyHint:
    "끄면 PocketRisu 내부 항목만, 켜면 기타 시스템·여유 공간까지 디스크 전체 기준으로 표시합니다.",

  // 2 GB BLOB 한계 (별도 섹션)
  storageBlobLimit: "2 GB BLOB 한계",
  storageBlobLimitDesc:
    "SQLite는 단일 행 값을 약 2 GB까지만 허용합니다. database.bin이 하나의 행이라 채팅·설정 합계가 이 값을 넘을 수 없으며, 한계에 가까워지면 저장이 실패하기 시작합니다.",
  storageBlobThreshold: (used: number, max: number, pct: number) =>
    `2 GB 중 ${pct.toFixed(1)}% (${(used / 1024 / 1024 / 1024).toFixed(2)} / ${(max / 1024 / 1024 / 1024).toFixed(2)} GB)`,
  storageBlobThresholdWarn:
    "2 GB BLOB 한계에 가까워지고 있습니다. 채팅이나 에셋을 정리하세요.",
  storageBlobThresholdCrit:
    "위험: 2 GB BLOB 한계가 임박했습니다. 저장이 실패할 수 있습니다.",

  storageOptimize: "지금 정리",
  storageOptimizing: "정리 중...",
  storageOptimizeHeader: (dbSize: number, reclaim: number) =>
    `${(dbSize / 1024 / 1024 / 1024).toFixed(2)} GB 중 ${(reclaim / 1024 / 1024).toFixed(1)} MB 회수 가능`,
  storageOptimizeBarUsed: "사용 중",
  storageOptimizeBarReclaimable: "회수 가능",
  storageOptimizeWhat:
    "캐릭터·채팅·에셋을 삭제해도 데이터베이스는 그 자리를 빈 공간으로 표시할 뿐 파일 크기는 줄어들지 않습니다. 정리는 이 빈 공간을 제거해 파일을 다시 써서 실제 크기를 줄입니다. 데이터는 변경되지 않습니다.",
  storageOptimizeWhen:
    "큰 삭제 작업 후나 위 막대의 빈 공간이 많이 쌓였을 때 실행하면 효과가 큽니다. 정리 중에는 서버 저장이 잠시 멈춥니다 (보통 수 초, 매우 큰 DB는 수십 초까지).",
  storageOptimizeConfirm: "지금 정리할까요? 서버 저장이 수 초간 멈춥니다.",
  storageOptimizeNeedsSpace: (need: number, free: number) =>
    `디스크 여유가 부족합니다. 약 ${(need / 1024 / 1024).toFixed(0)} MB 필요, 여유 ${(free / 1024 / 1024).toFixed(0)} MB.`,
  storageOptimizeDone: (reclaimed: number, ms: number) =>
    `${(reclaimed / 1024 / 1024).toFixed(1)} MB 회수 (${(ms / 1000).toFixed(1)}초).`,
  storageOptimizeFailed: "정리 실패",

  storageCleanup: "SQLite 오버헤드 정리",

  storageOrphan: "고아 미디어",
  storageOrphanHeader: (count: number, size: number) =>
    `${count}개 · ${(size / 1024 / 1024).toFixed(1)} MB`,
  storageOrphanWhat:
    "캐릭터·모듈·페르소나 어디에서도 참조하지 않는 이미지 파일입니다. 캐릭터를 지우거나 에셋을 교체할 때 남습니다.",
  storageOrphanWhen:
    "삭제된 파일은 복구할 수 없습니다. 중요한 데이터가 있다면 백업을 먼저 만드세요. 정리 후에는 위의 \"SQLite 오버헤드 정리\"까지 실행해야 파일 크기가 실제로 줄어듭니다.",
  storageOrphanUnavailable:
    "아직 검사할 수 없습니다. 데이터베이스가 서버 메모리에 올라온 뒤 새로고침하세요.",
  storageOrphanPurge: "고아 미디어 정리",
  storageOrphanPurging: "고아 미디어 정리 중...",
  storageOrphanConfirm: (count: number, size: number) =>
    `참조되지 않는 미디어 ${count}개(${(size / 1024 / 1024).toFixed(1)} MB)를 삭제할까요? 되돌릴 수 없습니다.`,
  storageOrphanDone: (count: number, size: number) =>
    `${count}개 삭제 (${(size / 1024 / 1024).toFixed(1)} MB).`,
  storageOrphanFailed: "고아 미디어 정리 실패",
  storageOrphanAutoClean: "부팅 시 자동 정리",
  storageOrphanAutoCleanDesc:
    "앱을 열 때마다 고아 미디어를 자동으로 지웁니다. 기본은 꺼짐 — 아직 알려지지 않은 참조까지 지울 수 있어 수동 정리를 권장합니다.",

  storageSaveMetrics: "저장 성능",
  storageSaveMetricsHeader: (n: number) => `이 탭의 최근 ${n}회`,
  storageSaveMetricsDesc:
    "이 탭에서 최근 저장에 걸린 시간입니다. 저장이 느리거나 자주 실패하면 '진단 복사' 내용을 제보에 함께 붙여 주세요. 경로·이름·내용은 들어가지 않습니다.",
  storageSaveMetricsEmpty: "아직 저장 기록이 없습니다. 편집하면 여기에 쌓입니다.",
  storageSaveMetricsCounts: "저장 방식",
  storageSaveMetricsCountsValue: (patch: number, full: number, retry: number, error: number) =>
    `부분 ${patch} · 전체 ${full} · 재시도 ${retry} · 실패 ${error}`,
  storageSaveMetricsTime: "저장 시간 (중앙값 / 상위 10%)",
  storageSaveMetricsServer: "서버 처리 (중앙값)",
  storageSaveMetricsQueue: "서버 대기열 대기 (중앙값)",
  storageSaveMetricsPersist: "마지막 디스크 기록",
  storageSaveMetricsCopy: "진단 복사",

  storageWalCleanup: "WAL 수동 정리",
  storageWalCleanupHeader: (walSize: number) =>
    `현재 WAL ${(walSize / 1024 / 1024).toFixed(1)} MB`,
  storageWalCleanupWhat:
    "SQLite의 WAL 파일(risuai.db-wal)은 최근 변경분이 본 DB로 합쳐지기 전 임시로 모아두는 영역입니다. 5분 주기로 자동 정리되지만 백업 임포트나 큰 에셋 업로드 직후 일시적으로 부풀 수 있습니다.",
  storageWalCleanupWhen:
    "WAL 파일이 커진 상태에서 디스크 공간을 즉시 회수하고 싶을 때 사용합니다. Optimize와 달리 수 밀리초로 끝나고 추가 디스크 공간도 필요하지 않습니다. 데이터는 변경되지 않습니다.",
  storageWalCleanup_btn: "WAL 정리",
  storageWalCleanuping: "WAL 정리 중...",
  storageWalCleanupConfirm: "WAL을 지금 정리할까요? 서버 저장이 잠시 멈춥니다.",
  storageWalCleanupDone: (reclaimed: number, ms: number) =>
    `${(reclaimed / 1024 / 1024).toFixed(1)} MB 회수 (${ms}ms).`,
  storageWalCleanupNoop: "WAL은 이미 깨끗합니다.",
  storageWalCleanupFailed: "WAL 정리 실패",

  storageBackups: "백업",
  storageBackupsManage: "백업 관리",
  storageBackupsAuto: "스냅샷 (DB만)",
  storageBackupsAutoDesc:
    "주기적으로 자동 생성되는 빠른 복구용 스냅샷입니다. risuai.db 안에 저장되며, 설정된 한도에 따라 오래된 것부터 자동으로 정리됩니다. 캐릭터 에셋과 inlay는 포함되지 않습니다.",
  storageBackupsManual: "서버 백업",
  storageBackupsManualDesc:
    "캐릭터 에셋과 inlay 이미지를 모두 포함하는 풀 백업입니다. 서버 스토리지에 직접 저장되며, 보관 위치는 변경 가능합니다.",
  storageBackupsCount: (count: number, size: number) =>
    `${count}개 · ${(size / 1024 / 1024).toFixed(1)} MB`,
  storageBackupsRange: (oldest: string, newest: string) =>
    `최신 ${newest} · 가장 오래된 것 ${oldest}`,
  storageBackupsEmpty: "없음",

  storageCharacters: "캐릭터별 점유",
  storageCharactersDesc:
    "각 캐릭터의 카드, 미디어, 채팅 용량 근사값을 측정합니다.",
  storageCharactersMeasure: "측정",
  storageCharactersMeasuring: "측정 중...",
  storageCharactersDone: (ms: number, count: number) =>
    `캐릭터 ${count.toLocaleString()}개 측정 (${(ms / 1000).toFixed(1)}초). 채팅 용량은 근사값입니다.`,
  storageCharactersCard: "카드",
  storageCharactersImage: "미디어",
  storageCharactersChat: "채팅",
  storageCharactersTrashed: "휴지통",
  storageCharactersGoTo: "이 캐릭터로 이동",
  storageCharactersDeactivated: "비활성화",
  storageArchiveOrphanHeader: (count: number, size: number) =>
    `참조되지 않는 비활성화 데이터: ${count}개, ${(size / 1024 / 1024).toFixed(1)} MB`,
  storageArchiveOrphanDesc:
    "다시 활성화했거나 삭제·백업 복원으로 목록에서 빠진 캐릭터의 보관 데이터입니다. 스냅샷 복원에 대비해 자동으로 지우지 않습니다.",
  storageArchiveOrphanPurge: "보관 데이터 정리",
  storageArchiveOrphanConfirm: (count: number, size: number) =>
    `참조되지 않는 비활성화 데이터 ${count}개(${(size / 1024 / 1024).toFixed(1)} MB)를 삭제할까요? 이 데이터를 가리키는 옛 스냅샷은 복원 후 해당 캐릭터를 열 수 없게 됩니다. 되돌릴 수 없습니다.`,
  storageArchiveOrphanDone: (count: number, size: number) =>
    `비활성화 데이터 ${count}개(${(size / 1024 / 1024).toFixed(1)} MB)를 정리했습니다.`,
  storageCharactersDeactivatedMissing: "비활성화 · 데이터 없음",
  storageCharactersOrphan: (count: number, size: number) =>
    `고아 미디어 (어떤 캐릭터도 참조하지 않음): ${count}개, ${(size / 1024 / 1024).toFixed(1)} MB`,
  storageCharactersEmpty: "캐릭터 없음",
  storageLoadMore: (remaining: number) =>
    `더 보기 (${remaining.toLocaleString()}개 남음)`,
  storageShowingOf: (shown: number, total: number) =>
    `${total.toLocaleString()}개 중 ${shown.toLocaleString()}개 표시`,

  storageModules: "모듈별 점유",
  storageModulesDesc: "각 모듈의 본문과 에셋 용량을 측정합니다.",
  storageModulesMeasure: "측정",
  storageModulesMeasuring: "측정 중...",
  storageModulesDone: (ms: number, count: number) =>
    `모듈 ${count.toLocaleString()}개 측정 (${(ms / 1000).toFixed(1)}초).`,
  storageModulesBody: "본문",
  storageModulesAssets: "에셋",
  storageModulesEmpty: "모듈 없음",

  storageDebug: "디버그 정보",

  // 데이터 이전 (구 "계정 & 파일")
  migration: "데이터 이전",
  migrationDesc:
    "원본 RisuAI(또는 호환 시스템)에서 데이터를 가져오거나 PocketRisu 데이터를 원본 호환 형식으로 내보냅니다.",
  migrationInfoBackupMoved:
    "서버 백업, 로컬 백업, 자동 스냅샷 관리는 [시스템 → 백업] 탭으로 이동했습니다.",
  migrationGotoBackupTab: "백업 탭 열기",
  migrationLegacyAccordion: "기존 리스 방식으로 백업 (레거시)",
  migrationLegacyDesc:
    "원본 RisuAI 호환 포맷으로 백업·내보내기를 수행하는 보조 기능들입니다. 일반적인 백업 작업은 백업 탭을 사용하세요.",
  migrationSaveFolderAccordion: "노드리스에서 save 폴더 가져오기",
  migrationSaveFolderDesc:
    "이전에 사용하던 노드리스/RisuAI 인스턴스의 save 폴더를 PocketRisu로 가져올 때 사용합니다.",
  migrationLoadUpstreamBackup: "원본 리스 로컬 백업 불러오기",
  risuAccountImport: "RisuAI 계정에서 가져오기",
  risuAccountImportDesc:
    "risuai.xyz에서 \"계정에 데이터 저장\"을 켜 두었다면, 계정의 캐릭터, 채팅, 설정, 이미지를 이 서버로 옮겨 옵니다. 웹 버전 백업 파일이 열리지 않을 때 쓰세요.",
  risuAccountLogin: "RisuAI 로그인",
  risuAccountLoginTitle: "RisuAI 계정 로그인",
  risuAccountLoginDesc:
    "아이디와 비밀번호는 RisuAI로만 전송됩니다. 돌려받은 로그인 토큰은 가져오기가 끝날 때까지 이 서버 메모리에만 있고 저장되지 않습니다.",
  risuAccountChecking: "계정 데이터를 확인하는 중…",
  risuAccountCheckingRemotes: (n: number) =>
    `계정 데이터를 확인하는 중… (캐릭터 ${n.toLocaleString()}개 읽음)`,
  risuAccountSummaryCharacters: (n: number) => `캐릭터 ${n.toLocaleString()}개`,
  risuAccountSummaryChats: (n: number) => `채팅 ${n.toLocaleString()}개`,
  risuAccountSummaryAssets: (n: number, staged: number) =>
    `이미지 ${n.toLocaleString()}장${staged > 0 ? ` (이미 받음 ${staged.toLocaleString()}장)` : ""}`,
  risuAccountSummaryCold: (n: number) => `보관된 항목 ${n.toLocaleString()}개`,
  risuAccountEstimate: (time: string) => `예상 시간 약 ${time}`,
  risuAccountMinutes: (n: number) => `${n.toLocaleString()}분`,
  risuAccountHours: (h: number, m: number) => `${h.toLocaleString()}시간 ${m}분`,
  risuAccountUnresolvedRemotes: (n: number) =>
    `캐릭터 ${n.toLocaleString()}개는 계정에 내용이 없어 가져올 수 없습니다. RisuAI 데스크톱 앱에서 저장한 캐릭터라면 그 앱에서 일반 백업으로 옮기세요.`,
  risuAccountSkipped: (n: number) =>
    `이름이 올바르지 않은 항목 ${n.toLocaleString()}개는 건너뜁니다.`,
  risuAccountDamaged: (n: number, names: string) =>
    `계정 데이터 중 손상되어 읽을 수 없는 항목 ${n.toLocaleString()}개가 있습니다 (${names}). 바꿀 때 이 항목은 빠집니다.`,
  risuAccountStartWarn:
    "가져오기를 시작하면 끝날 때까지 PocketRisu를 쓸 수 없고, 끝나면 이 서버의 모든 데이터가 계정 데이터로 바뀝니다.",
  risuAccountSnapshotNote:
    "계정 데이터는 방금 로그인한 시점 기준입니다. 받는 동안 RisuAI 웹에서 한 채팅은 들어오지 않습니다.",
  risuAccountInlayNote:
    "채팅에 넣은 이미지(인레이)는 브라우저에만 저장돼 있어 가져오지 않습니다.",
  risuAccountStart: "가져오기 시작",
  risuAccountConfirm1Title: "지금 데이터를 계정 데이터로 바꿉니다",
  risuAccountConfirm1: (time: string) =>
    `이 서버의 캐릭터, 채팅, 설정, 이미지가 모두 RisuAI 계정 데이터로 바뀝니다. 다 받는 동안(약 ${time}) PocketRisu를 쓸 수 없습니다.`,
  risuAccountContinue: "계속",
  risuAccountConfirm2Title: "정말 바꿀까요?",
  risuAccountConfirm2:
    "되돌리려면 교체 직전에 남는 데이터베이스 스냅샷을 불러와야 합니다. 이미지는 스냅샷에 남지 않으니, 필요하면 먼저 백업하세요.",
  risuAccountConfirmStart: "데이터 바꾸고 시작",
  risuAccountSaveFailed: "저장하지 못한 변경이 있어 가져오기를 시작하지 않았습니다. 잠시 뒤 다시 시도하세요.",
  risuAccountScreenTitle: "RisuAI 계정에서 가져오는 중",
  risuAccountScreenDesc: "끝나면 데이터가 계정 데이터로 바뀌고 자동으로 새로고침됩니다.",
  risuAccountStepCheck: "계정 데이터 확인",
  risuAccountStepCold: "보관된 항목",
  risuAccountStepAssets: "이미지",
  risuAccountStepApply: "데이터 교체",
  risuAccountRemaining: (time: string) => `남은 시간 약 ${time}`,
  risuAccountScreenNote:
    "이 창을 닫아도 서버가 계속 받습니다. 다른 기기에서 열어도 이 화면이 보입니다. RisuAI 서버에 부담을 주지 않도록 1초에 하나씩 받습니다.",
  risuAccountCancel: "가져오기 취소",
  risuAccountCancelConfirm: "가져오기를 취소할까요? 받은 파일은 지워지고, 지금 데이터는 그대로 남습니다.",
  risuAccountPaused: "RisuAI 서버에 연결하지 못해 멈췄습니다. 잠시 뒤 다시 시도하세요.",
  risuAccountKeptFiles: "받은 파일은 그대로 있습니다.",
  risuAccountRetry: "다시 시도",
  risuAccountNeedsLogin:
    "RisuAI 로그인이 만료됐습니다. 다시 로그인하면 이어서 받습니다. 이미 받은 파일은 다시 받지 않습니다.",
  risuAccountRelogin: "다시 로그인",
  risuAccountInterruptedTitle: "멈춘 가져오기가 있습니다",
  risuAccountInterrupted:
    "서버가 다시 시작돼 가져오기가 멈췄습니다. 같은 계정으로 다시 로그인하면 남은 것만 받고 이어서 바꿉니다.",
  risuAccountStagedFiles: (staged: number, total: number) =>
    `받은 파일 ${staged.toLocaleString()}/${total.toLocaleString()}`,
  risuAccountDataUnchanged: "지금 데이터는 아직 그대로입니다.",
  risuAccountReloginResume: "다시 로그인해서 이어 받기",
  risuAccountDownloaded: "다 받았습니다",
  risuAccountMissingAsk: (n: number) =>
    `${n.toLocaleString()}개 항목을 계정에서 찾지 못했거나 읽을 수 없습니다. 이 항목 없이 바꿀까요?`,
  risuAccountMissingAssets: (n: number) => `이미지 ${n.toLocaleString()}개`,
  risuAccountMissingCold: (n: number) => `보관된 항목 ${n.toLocaleString()}개`,
  risuAccountMissingNotFound: "계정에 없음",
  risuAccountMissingUnreadable: "읽을 수 없음",
  risuAccountApplyAuto: "빠진 항목이 없으면 이 화면 없이 바로 바꿉니다.",
  risuAccountApplyWithout: "이 항목 없이 바꾸기",
  risuAccountApplyFailed: "데이터를 바꾸지 못했습니다. 지금 데이터는 그대로입니다.",
  risuAccountApplyRetry: "다시 바꾸기",
  risuAccountApplyingTitle: "데이터를 바꾸는 중",
  risuAccountApplyingDesc: "몇 초에서 몇 분 걸립니다. 끝나면 자동으로 새로고침됩니다.",
  risuAccountDone: "가져오기를 마쳤습니다. 새로고침합니다…",
  risuAccountImportActive:
    "가져오기가 진행 중입니다\n\n다른 기기에서 RisuAI 계정 가져오기를 시작해서 이 기기에서는 저장할 수 없습니다. 새로고침하면 진행 상황이 보입니다.",
  risuAccountErrorLoginFailed: "RisuAI가 로그인을 거부했습니다. 다시 로그인해 주세요.",
  risuAccountErrorNoData:
    "이 계정에는 저장된 데이터가 없습니다. RisuAI에서 \"계정에 데이터 저장\"이 켜져 있는지 확인하세요.",
  risuAccountErrorRequestFailed: "RisuAI 서버에 연결하지 못했습니다. 잠시 후 다시 시도하세요.",
  risuAccountErrorUnreadable: "계정 데이터를 읽지 못했습니다.",
  risuAccountErrorRateLimited: "RisuAI 서버가 잠시 뒤에 다시 요청하라고 했습니다. 나중에 다시 시도하세요.",
  risuAccountErrorDiskFull: "서버의 디스크 여유 공간이 부족합니다.",
  risuAccountErrorMismatch: "가져오기를 시작한 계정과 다른 계정입니다. 같은 계정으로 로그인하세요.",
  risuAccountErrorStagedUnreadable: "받아 둔 계정 데이터를 읽을 수 없습니다. 가져오기를 취소하고 처음부터 다시 시작하세요.",

  // 시스템 → 백업 탭
  systemBackups: "백업",
  backupTabDesc: "스냅샷, 백업, 로컬 백업을 한곳에서 관리합니다.",

  backupSnapshot: "스냅샷 (DB만)",
  backupSnapshotEmpty: "스냅샷이 없습니다.",
  backupSnapshotRestore: "이 스냅샷으로 복원",
  backupSnapshotDelete: "스냅샷 삭제",
  backupSnapshotDeleteConfirm: (when: string) =>
    `${when} 스냅샷을 삭제할까요? 되돌릴 수 없습니다.`,
  backupSnapshotDeleted: "스냅샷이 삭제되었습니다.",
  backupSnapshotDeleteFailed: "스냅샷 삭제 실패",
  backupSnapshotLimits: (count: number, bytes: number) =>
    `최대 ${count}개 · ${(bytes / 1024 / 1024).toFixed(0)} MB`,
  backupSnapshotLimitsCurrent: (count: number, bytes: number, logicalBytes?: number) => {
    const disk = (bytes / 1024 / 1024).toFixed(1)
    const saved = (logicalBytes ?? 0) - bytes
    // Only surface the dedup win when it's meaningful (chunked snapshots share
    // chunks); for tiny/un-chunked sets logical ≈ disk, so the plain line reads
    // cleaner without a "(0 MB saved)" tail.
    if (saved > 1024 * 1024) {
      const data = ((logicalBytes ?? 0) / 1024 / 1024).toFixed(0)
      const savedMB = (saved / 1024 / 1024).toFixed(0)
      return `현재 ${count}개 · 디스크 ${disk} MB (데이터 ${data} MB, 중복 제거로 ${savedMB} MB 절약)`
    }
    return `현재 ${count}개 · ${disk} MB 사용`
  },
  backupSnapshotLimitsChange: "한도 설정",
  backupSnapshotLimitsDialog: "스냅샷 보관 한도",
  backupSnapshotLimitsDialogDesc:
    "두 한도 중 먼저 도달하는 쪽이 적용됩니다. 새 스냅샷이 생성될 때 자동으로 회전되며, 한도를 줄이면 즉시 정리됩니다 (가장 최신 1개는 한도 무관 보존).",
  backupSnapshotLimitsCount: "최대 개수",
  backupSnapshotLimitsBytes: "최대 용량 (MB)",
  backupSnapshotLimitsSuccess: (removed: number) =>
    removed > 0
      ? `한도 적용 완료 (${removed}개 정리됨)`
      : "한도가 변경되었습니다.",
  backupSnapshotLimitsFailed: "한도 변경 실패",
  backupSnapshotLimitsCountRange: (min: number, max: number) =>
    `${min}-${max} 사이 정수`,
  backupSnapshotLimitsBytesRange: (minMB: number, maxMB: number) =>
    `${minMB}-${maxMB.toLocaleString()} MB 사이`,

  backupServer: "서버 백업",
  backupServerDesc:
    "캐릭터 에셋과 inlay 이미지를 모두 포함하는 풀 백업입니다. 서버 스토리지에 직접 저장되며, 보관 위치는 아래에서 변경할 수 있습니다.",
  backupServerCreate: "백업 만들기",
  backupServerEmpty: "저장된 백업이 없습니다.",
  backupBootReminder: "부팅 시 백업 알림",
  backupBootReminderHint: "다음 부팅부터 백업할지 묻는 팝업이 뜹니다.",
  backupBootReminderToggledOn: "부팅 시 백업 알림이 켜졌습니다.",
  backupBootReminderToggledOff: "부팅 시 백업 알림이 꺼졌습니다.",
  backupBootPromptTitle: "지금 서버 백업을 만들까요?",
  backupBootPromptEstimate: (size: number) =>
    `예상 백업 크기: ${(size / 1024 / 1024).toFixed(0)} MB`,
  backupBootPromptDisk: (free: number, total: number) =>
    `디스크 여유: ${(free / 1024 / 1024 / 1024).toFixed(1)} GB / 전체 ${(total / 1024 / 1024 / 1024).toFixed(1)} GB`,
  backupBootPromptProceed: "지금 백업",
  backupBootPromptSkip: "건너뛰기",
  storageDiskUsageHighWarning: (pct: number) =>
    `디스크 사용량 ${pct.toFixed(0)}% — 정리가 필요합니다.`,
  backupServerInsufficient: "디스크 여유 부족 — 새 백업을 만들 수 없습니다.",
  updatePopupBackup: "백업",

  backupServerPath: "보관 위치",
  backupServerPathDefault: "기본 위치",
  backupServerPathChange: "변경",
  backupServerPathDialog: "백업 보관 위치 변경",
  backupServerPathDialogDesc:
    "새 백업이 저장될 폴더의 절대 경로를 입력하세요. 기존 백업 파일은 이전 위치에 그대로 남으며 자동으로 옮겨지지 않으므로, 필요하면 직접 옮겨주세요.",
  backupServerPathInputLabel: "절대 경로",
  backupServerPathSuccess: "보관 위치가 변경되었습니다.",
  backupServerPathFailed: "보관 위치 변경 실패",

  backupLocal: "로컬 백업",
  backupLocalDesc:
    "사용자 기기로 백업을 다운로드하거나 기기 파일에서 복원합니다.",
  backupLocalDownload: "로컬 백업 다운로드",
  backupLocalDownloadDesc:
    "현재 데이터로 새 백업을 만들어 사용자 기기로 즉시 다운로드합니다.",
  backupLocalRestoreDesc: "사용자 기기의 백업 파일에서 복원합니다.",

  backupSettingsOnly: "설정만 내보내기",
  backupSettingsOnlyDesc:
    "캐릭터와 채팅 기록, 인레이 이미지를 빼고 설정만 내보냅니다. 모듈, 플러그인, 프리셋, 페르소나, 로어북, 테마, API 키는 그대로 담깁니다. 새 인스턴스를 세팅할 때 쓰세요.",
  backupSettingsOnlyEstimating: "용량 확인 중...",
  backupSettingsOnlyConfirm: (size: string) =>
    `새 인스턴스에 옮길 설정 백업을 만듭니다. 약 ${size}입니다.\n\n• 담기는 것: 설정, API 키, 모듈, 플러그인, 프리셋, 페르소나, 로어북, 테마\n• 빠지는 것: 캐릭터, 채팅 기록, 인레이 이미지\n\n복원하면 그 기기의 기존 데이터를 덮어씁니다. 캐릭터가 있는 기기보다는 새 인스턴스에 쓰는 것을 권장합니다.`,
  backupSettingsOnlyBreakdown: (
    baseSize: string,
    moduleCount: number,
    assetCount: number,
    moduleSize: string,
  ) =>
    `새 인스턴스에 옮길 설정 백업을 만듭니다. 캐릭터와 채팅 기록, 인레이 이미지는 빠집니다.\n\n• 설정, API 키, 모듈, 플러그인, 프리셋, 페르소나, 로어북, 테마: ${baseSize}\n• 모듈 에셋 (모듈 ${moduleCount}개, 이미지 ${assetCount.toLocaleString()}장): ${moduleSize}\n\n에셋을 빼도 모듈 자체는 그대로 옮겨집니다. 다만 이미지가 비어 보이며, 새 인스턴스에서 해당 모듈을 다시 받으면 채워집니다.`,
  backupSettingsOnlyWithModuleAssets: (size: string) => `모듈 에셋 포함 (${size})`,
  backupSettingsOnlyWithoutModuleAssets: (size: string) => `설정만 (${size})`,
  backupSettingsOnlyModuleAssetsSkipped:
    "설정 백업을 저장했습니다.\n\n**모듈 에셋은 담기지 않았습니다.** 복원한 인스턴스에서 모듈 목록과 설정은 그대로 보이지만 이미지는 비어 있습니다. 해당 모듈을 다시 받으면 채워집니다.",

  relatedGithub: "GitHub",
  relatedGithubDesc: "Star를 눌러 프로젝트를 응원해주세요.",
  support: "후원",
  supportBanner: "PocketRisu를 후원해 주세요",
  supportTitle: "PocketRisu 후원",
  supportThanks: "후원해 주셔서 감사합니다",
  supportButton: "Patreon에서 후원하기",
  supportSetName: "후원자 이름 게시하기",
  supportNotice: "후원은 전적으로 자유이며, 후원자 이름 게시 외에 추가 기능이나 혜택은 제공되지 않습니다.",
  supportNoticeWarn: "아카라이브 AI 채팅 채널에서는 후원 관련 언급이 규정으로 금지되어 있으니 주의해 주세요.",
  supportStatActive: "현재 정기 후원자",
  supportStatLifetime: "누적 후원자",
  supportCaptionActive: "매달 함께하고 있는 분들이에요",
  supportCaptionLifetime: "지금까지 함께해 주신 모든 분들이에요",
  supportPerMonth: "월",
  supportEmpty: "첫 후원자가 되어주세요",
  supportLoadFailed: "후원자 목록을 불러오지 못했습니다",
  supportRetry: "다시 시도",
  supportDisabled: "이 서버는 업데이트 확인이 꺼져 있어 후원자 목록을 표시하지 않습니다",
  supportUpstream: "원본 RisuAI 후원하기",
  relatedFeedbackForm: "의견 보내기",
  relatedFeedbackFormDesc: "이슈 제보 및 의견을 보내주세요.",
  relatedContactEmail: "개발자 이메일",
  relatedContactEmailDesc: "개발자에게 직접 메일을 보낼 수 있어요.",
  relatedArcaLive: "아카라이브 채널",
  relatedArcaLiveDesc: "AI 채팅 채널에서 다른 사용자와 이야기를 나눠보세요.",

  selectBotHint: "채팅을 시작할 봇을 선택하세요",
  recentChatsTitle: "최근 대화",
  noRecentChatsDesc: "아직 대화한 봇이 없어요",
  hideRecentChats: "대화 목록 숨기기",
  hideDeactivatedCharacters: "비활성화된 캐릭터 숨기기",
  hiddenFromSidebarHint: "사이드바에서만 숨겨지며 데이터에는 영향이 없습니다. 비활성화와 달리 성능에도 영향이 없습니다.",

  characterManager: "캐릭터 관리",
  characterManagerHint: "사용하지 않는 캐릭터는 비활성화하거나 휴지통으로 보내 두면 로딩과 저장이 가벼워집니다. 데이터는 서버에 보관되며 언제든 다시 활성화하거나 복원할 수 있습니다.",
  characterListSettings: "캐릭터 목록 설정",
  sortSidebarOrder: "사이드바 순서",
  sortRecentChats: "최근 대화순",
  sortByName: "이름순",
  sortByCreated: "추가일순",
  sortByChatCount: "채팅 수",
  hiddenBadge: "숨김",
  hideFromSidebar: "사이드바에서 숨기기",
  showInSidebar: "사이드바에 표시",
  selectionCount: (n: number) => `${n}개 선택`,
  clearSelection: "선택 해제",
  folderSettings: "폴더 설정",
  folderColor: "폴더 색상",
  folderImage: "폴더 이미지",
  selectImage: "이미지 선택",
  resetImage: "기본 이미지로",
  moveOutOfFolder: "폴더 밖으로",
  noFolder: "폴더 밖",
  restore: "복원",
  deletePermanently: "영구 삭제",
  deactivateSelectedConfirm: (n: number) => `선택한 ${n}개 캐릭터를 비활성화할까요?\n\n사용하지 않는 캐릭터를 비활성화하면 성능 개선에 도움이 됩니다. 데이터는 서버에 보관되며 언제든 다시 활성화할 수 있습니다.`,
  trashSelectedConfirm: (n: number) => `선택한 ${n}개 캐릭터를 휴지통으로 보낼까요?`,
  noCharactersFound: "캐릭터가 없습니다",
  openCharacter: "열기",
  activateCharacter: "캐릭터 활성화",
  filterAll: "전체 보기",
  filterHiddenOnly: "숨긴 캐릭터만",
  filterArchivedOnly: "비활성화만",
  folderIcon: "폴더 아이콘",
  folderShowName: "아이콘에 폴더 이름 표시",
  followGlobalSetting: "전역 설정 따름",
  showLabel: "표시",
  hideLabel: "숨김",
  defaultLabel: "기본",
  emptyTrash: "휴지통 비우기",
  gridHideNames: "이름 숨기기",
  moveToTrash: "휴지통으로 보내기",
  moveToTrashConfirm: "휴지통으로 보낼까요? 캐릭터는 비활성화되어 서버에 보관되며, 휴지통에서 언제든 복원할 수 있습니다: ",
  trashCharacterDone: "휴지통으로 보냈습니다.",
  deleteCharacterFailed: "영구 삭제에 실패했습니다: ",
  folderDisplayMode: "표시 방식",
  folderModeIcon: "아이콘",
  folderModeImage: "이미지",
  folderModeName: "이름",
  folderImageHint: "이미지를 선택하면 아이콘 자리에 표시됩니다.",
  emptyTrashConfirm: (n: number) => `휴지통의 캐릭터 ${n}개를 영구 삭제할까요? 되돌릴 수 없습니다.`,

  showRequestStatus: "요청 상태 표시",
  requestStatus: {
    connecting: "요청 중…",
    thinking: "사고 중…",
    responding: "응답 중…",
    retrying: "재시도 중…",
    stalled: "멈춤…",
    background: "백그라운드 진행 중…",
    done: "완료",
    failed: "실패",
    aborted: "취소됨",
    kindMain: "메인",
    kindTranslate: "번역",
    kindMemory: "메모리",
    kindEmotion: "감정",
    kindSub: "보조",
    outputTokens: "출력",
    thinkingTokensLabel: "사고",
    tokensPerSec: "tok/s",
    cacheHit: "캐시 적중 · {n} 토큰",
  },
  settingActionAdd: "추가",
  settingActionRename: "이름 변경",
  settingActionView: "보기",
  settingActionExport: "내보내기",
  settingActionImport: "가져오기",
  settingActionClear: "지우기",
  showStatistics: "사용 통계",
  showStatisticsDesc: "지금까지 누적된 사용 통계를 표로 보여줍니다.",
  exportSettingsReport: "버그 제보용 설정 내보내기",
  exportSettingsReportDesc: "API 키·캐릭터 등 개인 정보를 뺀 설정을 파일로 받고 클립보드에 복사합니다.",
  banCharactersetDesc: "선택한 문자 집합이 섞인 응답을 받으면 자동으로 다시 생성합니다.",
  inlayCompressAllDesc: "저장된 모든 인레이 이미지를 다시 압축해 저장 용량을 줄입니다.",
  advTabPrompt: "프롬프트·생성",
  advTabRequest: "요청·모델",
  advTabAssets: "화면·에셋",
  advTabDev: "개발·실험",
  advSectionResponse: "응답 보정",
  advSectionDevTools: "개발 도구",
  advSectionExperimental: "실험적 기능",
  risuTosTitle: "RisuAI 이용약관 동의",
  risuTosDesc: "이 기능은 RisuAI가 운영하는 서버를 사용합니다.\nPocketRisu는 RisuAI와 별개의 독립 프로젝트이며, 아래 약관은 PocketRisu가 아닌 RisuAI의 약관입니다. 동의하지 않아도 PocketRisu의 다른 기능은 그대로 사용할 수 있습니다.",
  risuTosScope: "이 약관은 다음 기능에만 적용됩니다:",
  risuTosScopeRealm: "RisuRealm (캐릭터 둘러보기·검색·다운로드·신고)",
  risuTosScopeMcp: "MCP 서버 OAuth 로그인 (RisuAI 계정 서버를 통한 인증 중계)",
  risuTosScopeAccountImport: "RisuAI 계정에서 가져오기 (로그인, 계정에 저장된 데이터 받기)",
  risuTosTerms: "RisuAI 이용약관",
  risuTosPrivacy: "RisuAI 개인정보처리방침",
  risuTosAccept: "동의",
  risuTosDecline: "동의하지 않음",
  risuTosGate: "RisuRealm은 RisuAI가 운영하는 서버를 사용합니다. 이용하려면 RisuAI 이용약관에 동의해야 합니다.",
  risuTosGateButton: "약관 확인",
  protonImport: "Proton 링크로 가져오기",
  protonImportTitle: "Proton Drive에서 가져오기",
  protonImportDesc: "drive.proton.me 공유 링크를 붙여넣으세요. 파일 링크와 폴더 링크 모두 됩니다.",
  protonImportOpen: "열기",
  protonImportInvalidLink: "Proton Drive 공유 링크를 찾지 못했습니다.",
  protonImportLoading: "링크를 여는 중...",
  protonImportImporting: "가져오는 중...",
  protonImportOnlyImportable: "가져올 수 있는 파일만",
  protonImportHidden: (count: number) => `다른 파일 ${count}개 숨김`,
  protonImportSortName: "이름순",
  protonImportSortNewest: "최신순",
  protonImportEmpty: "표시할 파일이 없습니다.",
  protonImportImported: "가져옴",
  protonImportUnsupported: "여기서 가져올 수 없는 파일입니다. Proton Drive에서 열어 주세요.",
  protonImportPassword: "추가 비밀번호가 필요한 링크입니다. 지금은 Proton Drive에서 열어 주세요.",
  protonImportLegacy: "지원하지 않는 예전 형식의 링크입니다. Proton Drive에서 열어 주세요.",
  protonImportFailed: "Proton Drive에서 파일을 받지 못했습니다.",
  protonImportOpenInProton: "Proton Drive에서 열기",
  protonImportDone: (name: string) => `${name}을(를) 가져왔습니다.`,
  protonImportAnother: "다른 링크 가져오기",
  protonImportBackToList: "목록으로",
  protonImportPluginConfirm: (name: string) => `${name}은(는) 플러그인입니다. 플러그인은 앱 안에서 코드를 실행하므로 믿을 수 있는 출처일 때만 설치하세요.`,
  protonImportInstall: "설치",
  protonImportNotice: "파일은 브라우저에서 복호화됩니다. PocketRisu는 Proton 공식 앱이 아닙니다.",
} satisfies DeepPartial<typeof import("./en").languageEnglish>;
